import React from 'react';

const defaultColor = '#006aff';
const defaultSize = '32';

export const LatitudeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      focusable="false"
      role="img"
      aria-label="Latitude Icon"
      data-testid="latitude-icon"
    >
      <g clipPath="url(#clip0_15594_5671)">
        <path
          d="M4.91221 19.0015H23.6093V23.9977H2.5101C1.07727 23.9977 -0.0839844 22.8364 -0.0839844 21.4036V0.306702H4.91221V19.0015ZM11.5683 5.99122C13.2236 5.99122 14.5628 4.64969 14.5628 2.99678C14.5628 1.34387 13.2213 0.00234124 11.5683 0.00234124C9.91543 0.00234124 8.5739 1.34387 8.5739 2.99678C8.5739 4.64969 9.91543 5.99122 11.5683 5.99122ZM17.9248 2.99444C17.9248 1.34153 19.2663 0 20.9192 0C22.5721 0 23.9137 1.34153 23.9137 2.99444C23.9137 4.64735 22.5721 5.98888 20.9192 5.98888C19.2663 5.98888 17.9248 4.64735 17.9248 2.99444ZM23.916 12.3477C23.916 14.0029 22.5745 15.3421 20.9216 15.3421C19.2687 15.3421 17.9271 14.0006 17.9271 12.3477C17.9271 10.6948 19.2687 9.35323 20.9216 9.35323C22.5745 9.35323 23.916 10.6948 23.916 12.3477Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_15594_5671">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FaceIdIcon = ({ size = defaultSize, color = defaultColor }) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} focusable="false" role="img">
      <path
        d="M7 20a1 1 0 011 1v3h3a1 1 0 110 2H7a1 1 0 01-1-1v-4a1 1 0 011-1zm18 0a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 110-2h3v-3a1 1 0 011-1zm-4-.189v.004c0 .37-.198.721-.529.887A9.955 9.955 0 0116 21.754a9.955 9.955 0 01-4.471-1.052.987.987 0 01-.529-.887v-.004a.996.996 0 011.449-.886 7.967 7.967 0 003.551.83 7.967 7.967 0 003.551-.83.996.996 0 011.449.886zM16 13a1 1 0 011 1v3a1 1 0 01-1 1h-1a1 1 0 110-2v-2a1 1 0 011-1zm-4-2a1 1 0 011 1v1a1 1 0 01-2 0v-1a1 1 0 011-1zm8 0a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm-9-5a1 1 0 010 2H8v3a1 1 0 01-2 0V7a1 1 0 011-1h4zm14 0a1 1 0 011 1v4a1 1 0 11-2 0V8h-3a1 1 0 110-2h4z"
        fill={color}
      />
    </svg>
  );
};

export const MailIcon = ({ size = defaultSize, color = defaultColor }) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} focusable="false" role="img">
      <path
        d="M26 8a1 1 0 011 1v14a1 1 0 01-1 1H6a1 1 0 01-1-1V9a1 1 0 011-1h20zm-1 3.079l-9 7.202-9-7.201V22h18V11.079zM23.149 10H8.85L16 15.72 23.149 10z"
        fill={color}
      />
    </svg>
  );
};

export const TickIcon = ({ size = defaultSize, color = defaultColor }) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} focusable="false" role="img">
      <path
        d="M13.51 20.47l9.737-11.129a1 1 0 011.506 1.318l-10.5 12a1 1 0 01-1.514-.01l-4.5-5.28A1 1 0 019.76 16.07l3.749 4.399z"
        fill={color}
      />
    </svg>
  );
};

export const SecureIcon = ({ size = 24, color = 'white' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox={`0 0 ${size - 1} ${size}`} fill="none">
      <g clipPath="url(#clip0_13377_581)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.49048 9.96875V8.77691C9.49252 8.11209 9.75779 7.47515 10.2282 7.00542C10.6987 6.53569 11.3361 6.27141 12.0009 6.27039L12.0032 6.27039C12.6673 6.27243 13.3037 6.53716 13.7733 7.00678C14.2429 7.47641 14.5076 8.11277 14.5097 8.77691L14.5097 8.77844L14.5097 9.96875H14.92C15.516 9.96875 16 10.4528 16 11.0487V15.8898C16 16.4848 15.516 16.9688 14.92 16.9688H9.079C8.484 16.9688 8 16.4848 8 15.8898V11.0487C8 10.4528 8.484 9.96875 9.079 9.96875H9.49048ZM13.5097 9.96875V8.77926C13.5083 8.37953 13.3489 7.99656 13.0662 7.71389C12.7836 7.43132 12.4008 7.27192 12.0012 7.27039C11.6013 7.27131 11.2179 7.43044 10.9348 7.71307C10.6516 7.99581 10.4919 8.37913 10.4905 8.77927V9.96875H13.5097Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2674 0.325361C11.457 0.117905 11.7252 -0.000195015 12.0063 2.41732e-07C12.2867 0.000196051 12.5542 0.118148 12.7434 0.325019L12.7441 0.32576L12.7462 0.328003L12.7657 0.348566C12.7848 0.368512 12.816 0.400645 12.8593 0.44344C12.9458 0.529064 13.0801 0.657147 13.2608 0.815537C13.6224 1.13261 14.1674 1.56925 14.8843 2.02946C16.3192 2.95054 18.4283 3.95729 21.127 4.30276C21.6261 4.36665 22 4.79147 22 5.29466V14.9451C22 14.9798 21.9977 15.0143 21.9948 15.0488C21.9931 15.0675 21.9908 15.0907 21.9874 15.1182C21.9808 15.1733 21.9703 15.2456 21.9539 15.3337C21.9212 15.51 21.8648 15.7492 21.768 16.0392C21.574 16.6205 21.2197 17.3997 20.5756 18.2796C19.291 20.0348 16.8946 22.1365 12.4459 23.8923C12.2007 24.0163 11.9056 24.0392 11.6296 23.9311C7.12937 22.1679 4.71295 20.0518 3.42174 18.2864C2.77819 17.4065 2.42445 16.6274 2.23095 16.0461C2.13442 15.7561 2.07826 15.5169 2.04567 15.3406C2.02938 15.2525 2.01899 15.1802 2.01238 15.1251C2.00908 15.0976 2.00672 15.0744 2.00505 15.0557L2.00301 15.031L2.00204 15.017C2.00097 14.9999 2 14.9756 2 14.9532V5.3C2 4.79683 2.37387 4.37202 2.87296 4.3081C5.57013 3.96267 7.6821 2.95466 9.12046 2.03197C9.83909 1.57097 10.3859 1.13352 10.7489 0.815798C10.9302 0.657082 11.0651 0.528714 11.1521 0.442868C11.1956 0.399961 11.227 0.367732 11.2462 0.34771L11.2658 0.327045L11.2674 0.325361ZM4 14.9013C4.00229 14.9181 4.00615 14.9436 4.01234 14.9771C4.02905 15.0674 4.06277 15.2168 4.12856 15.4144C4.25972 15.8084 4.52043 16.4007 5.03604 17.1057C6.03262 18.4682 8.02115 20.3044 11.9888 21.9209C15.9682 20.3037 17.9624 18.4637 18.9617 17.0984C19.4779 16.3932 19.7392 15.8004 19.8708 15.4061C19.9369 15.2082 19.9708 15.0587 19.9876 14.9682C19.9938 14.9349 19.9977 14.9095 20 14.8927V6.15189C17.358 5.67423 15.2693 4.65322 13.8039 3.71253C13.0309 3.21627 12.4281 2.74039 12.0049 2.374C11.5806 2.74093 10.9758 3.21793 10.2003 3.71537C8.7325 4.65698 6.64141 5.6792 4 6.15714V14.9013Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_13377_581">
          <rect width={size} height={size} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HourglassIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.027 13.143L15.684 17.973C14.684 17.695 13.414 17.528 12.028 17.528C10.641 17.528 9.37 17.695 8.37 17.974L12.027 13.143ZM16.027 4.556V6.63L14.681 8.407H9.373L8.027 6.63V4.556H16.027ZM19.027 20.5H18.027V18.09C18.027 17.872 17.956 17.661 17.824 17.487L14.07 12.528L17.824 7.569C17.956 7.395 18.027 7.184 18.027 6.966V4.556H19.027C19.594 4.556 20.054 4.095 20.054 3.528C20.054 2.96 19.594 2.5 19.027 2.5H5.027C4.46 2.5 4 2.96 4 3.528C4 4.095 4.46 4.556 5.027 4.556H6.027V6.966C6.027 7.184 6.098 7.396 6.23 7.569L9.985 12.528L6.23 17.487C6.098 17.661 6.027 17.872 6.027 18.09V20.5H5.027C4.46 20.5 4 20.96 4 21.528C4 22.095 4.46 22.556 5.027 22.556H19.027C19.594 22.556 20.054 22.095 20.054 21.528C20.054 20.96 19.594 20.5 19.027 20.5Z"
        fill="#414141"
      />
    </svg>
  );
};

export const ExternalLinkIcon = ({ size = 24, ...rest }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      role="img"
      {...rest}
    >
      <path
        d="M11 3.0001C11.552 3.0001 11.999 3.4471 11.999 4.0001C11.999 4.5511 11.552 5.0001 11 5.0001H5V19.0001H19V12.9861C19 12.4331 19.447 11.9861 19.999 11.9861C20.552 11.9861 20.999 12.4331 20.999 12.9861L21 19.0001C21 20.1041 20.104 21.0001 19 21.0001H5C3.895 21.0001 3 20.1041 3 19.0001V5.0001C3 3.8951 3.895 3.0001 5 3.0001H11ZM20.9988 2C21.1288 2 21.2598 2.026 21.3818 2.077C21.4938 2.124 21.5938 2.193 21.6808 2.275C21.6888 2.282 21.6988 2.285 21.7068 2.292L21.7228 2.316C21.8058 2.404 21.8748 2.504 21.9218 2.617C21.9728 2.739 21.9998 2.87 21.9998 3V9C21.9998 9.552 21.5518 10 20.9998 10C20.4468 10 19.9998 9.552 19.9998 9V5.414L15.7208 9.693C15.3298 10.084 14.6968 10.084 14.3068 9.693C13.9158 9.303 13.9158 8.669 14.3068 8.279L18.5848 4H14.9998C14.4468 4 13.9998 3.552 13.9998 3C13.9998 2.447 14.4468 2 14.9998 2H20.9988Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Utilities = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="53" viewBox="0 0 52 53" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7885 5.06738V18.2252H16.9314V5.06738C16.9314 2.99632 15.2525 1.31738 13.1814 1.31738H20.0385C22.1096 1.31738 23.7885 2.99632 23.7885 5.06738ZM13.1814 48.633H20.0385C22.1096 48.633 23.7885 46.9541 23.7885 44.883V21.3022H18.6457C17.6989 21.3022 16.9314 22.0698 16.9314 23.0165V44.883C16.9314 46.9541 15.2525 48.633 13.1814 48.633ZM38.9606 48.7645C43.6697 48.7645 47.4872 44.947 47.4872 40.2379C47.4872 35.5288 43.6697 31.7114 38.9606 31.7114C34.2516 31.7114 30.4341 35.5288 30.4341 40.2379C30.4341 44.947 34.2516 48.7645 38.9606 48.7645ZM40.9014 40.2383C40.9012 39.5509 41.0407 38.8708 41.3115 38.239C41.5822 37.6073 41.9785 37.0371 42.4764 36.5633C41.7559 35.8736 40.8487 35.4107 39.8675 35.2322C38.8862 35.0537 37.8741 35.1673 36.9569 35.559C36.0397 35.9507 35.2577 36.6033 34.7081 37.4355C34.1586 38.2678 33.8656 39.2432 33.8656 40.2406C33.8656 41.238 34.1586 42.2134 34.7081 43.0457C35.2577 43.8779 36.0397 44.5305 36.9569 44.9222C37.8741 45.3139 38.8862 45.4275 39.8675 45.249C40.8487 45.0705 41.7559 44.6076 42.4764 43.9179C41.978 43.4435 41.5813 42.8726 41.3105 42.24C41.0398 41.6074 40.9006 40.9264 40.9014 40.2383Z"
        fill="#B1DBFF"
      />
      <path
        d="M50.8437 21.5867H27.078V52.1257H50.8437V21.5867Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.8437 28.3551H27.078V52.1207H50.8437V28.3551Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9608 48.7648C43.6699 48.7648 47.4873 44.9473 47.4873 40.2382C47.4873 35.5291 43.6699 31.7117 38.9608 31.7117C34.2517 31.7117 30.4342 35.5291 30.4342 40.2382C30.4342 44.9473 34.2517 48.7648 38.9608 48.7648Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.9015 40.2386C40.9013 39.5512 41.0408 38.871 41.3116 38.2393C41.5823 37.6076 41.9787 37.0374 42.4765 36.5636C41.756 35.8739 40.8488 35.411 39.8676 35.2325C38.8863 35.054 37.8742 35.1676 36.957 35.5593C36.0398 35.951 35.2578 36.6036 34.7083 37.4358C34.1587 38.2681 33.8657 39.2435 33.8657 40.2409C33.8657 41.2383 34.1587 42.2137 34.7083 43.046C35.2578 43.8782 36.0398 44.5308 36.957 44.9225C37.8742 45.3142 38.8863 45.4278 39.8676 45.2493C40.8488 45.0708 41.756 44.6079 42.4765 43.9182C41.9781 43.4438 41.5814 42.8729 41.3107 42.2403C41.0399 41.6077 40.9007 40.9267 40.9015 40.2386V40.2386Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M48.6453 23.686H43.0718V26.2501H48.6453V23.686Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9608 26.2642C39.6728 26.2642 40.2499 25.687 40.2499 24.9751C40.2499 24.2632 39.6728 23.686 38.9608 23.686C38.2489 23.686 37.6718 24.2632 37.6718 24.9751C37.6718 25.687 38.2489 26.2642 38.9608 26.2642Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.8499 23.686V28.3548"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.0498 42.7683V52.1199H1.04828V42.7683"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.04828 18.2258H24.0498"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.72958 15.1824H9.09677"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.242 5.09583H20.6045"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.72958 21.5858H9.09677"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3045 1.31738H4.79828C2.72721 1.31738 1.04828 2.99632 1.04828 5.06738V44.883C1.04828 46.9541 2.72721 48.633 4.79828 48.633H20.3045C22.3756 48.633 24.0545 46.9541 24.0545 44.883V5.06738C24.0545 2.99632 22.3756 1.31738 20.3045 1.31738Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Groceries = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="54" viewBox="0 0 50 54" fill="none">
      <path d="M1.48373 30.5175H13.815V52.3249H1.48373V30.5175Z" fill="#FFC9E4" />
      <path d="M26.9259 12.5719H34.7466L38.1539 18.186H23.8431L26.9259 12.5719Z" fill="#FFC9E4" />
      <path d="M5.6372 25.1344H16.0215L14.0744 30.5172H2.00271L5.6372 25.1344Z" fill="#FFC9E4" />
      <path
        d="M1.78506 30.5907H13.7185V52.5889H2.95329C2.65812 52.6001 2.37034 52.4949 2.15187 52.2961C1.9334 52.0973 1.80169 51.8207 1.78506 51.5258V30.5907ZM1.78506 30.5907L5.62854 25.1578M13.7198 30.5907H19.5668V52.5889H13.7198V30.5907ZM13.7198 30.5907L16.6287 25.1578M19.5658 30.5902L16.6277 25.1578M43.9424 19.041V40.8581M43.9424 40.8581L42.342 43.8491M43.9424 40.8581L45.5429 41.8865M9.70024 21.7461V18.6677L10.7809 17.8908C10.9814 17.7596 11.2159 17.6898 11.4555 17.6898C11.6952 17.6898 11.9296 17.7596 12.1302 17.8908L13.4094 18.7086C13.6045 18.8341 13.8316 18.9009 14.0636 18.9009C14.2956 18.9009 14.5227 18.8341 14.7178 18.7086L16.0262 17.8441C16.2194 17.7135 16.4472 17.6437 16.6804 17.6437C16.9136 17.6437 17.1414 17.7135 17.3346 17.8441L18.6489 18.7086C18.8427 18.8317 19.0676 18.8971 19.2972 18.8971C19.5269 18.8971 19.7518 18.8317 19.9456 18.7086L21.3241 17.8266C21.5192 17.701 21.7463 17.6343 21.9783 17.6343C22.2103 17.6343 22.4374 17.701 22.6325 17.8266L23.8884 18.7086C24.0835 18.8341 24.3106 18.9009 24.5426 18.9009C24.7746 18.9009 25.0017 18.8341 25.1968 18.7086L26.587 17.8266C26.7821 17.701 27.0092 17.6343 27.2412 17.6343C27.4732 17.6343 27.7003 17.701 27.8954 17.8266L29.1104 18.7086C29.3076 18.837 29.538 18.9054 29.7733 18.9054C30.0087 18.9054 30.2391 18.837 30.4363 18.7086L31.733 17.8558C31.9282 17.7302 32.1553 17.6635 32.3873 17.6635C32.6193 17.6635 32.8464 17.7302 33.0415 17.8558L34.3499 18.7086C34.5456 18.8353 34.7738 18.9028 35.007 18.9028C35.2402 18.9028 35.4684 18.8353 35.6641 18.7086L36.9492 17.8616C37.1486 17.7302 37.3821 17.6602 37.6209 17.6602C37.8597 17.6602 38.0933 17.7302 38.2927 17.8616L38.684 18.142C38.7657 18.2012 38.8585 18.2436 38.9568 18.2666C39.0551 18.2896 39.157 18.2927 39.2565 18.2759C39.356 18.259 39.4512 18.2225 39.5364 18.1684C39.6217 18.1143 39.6953 18.0438 39.7529 17.9609L40.3371 16.9971C40.47 16.7816 40.6672 16.6132 40.9009 16.5157C41.1346 16.4183 41.393 16.3966 41.6396 16.4539H41.7565C41.994 16.5076 42.2422 16.489 42.4691 16.4005C42.6961 16.312 42.8913 16.1577 43.0298 15.9574L43.7658 14.7891C43.9138 14.5737 44.1271 14.4115 44.3742 14.3263C44.6213 14.2411 44.8892 14.2375 45.1385 14.316C45.3712 14.3881 45.62 14.39 45.8538 14.3215C46.0875 14.2529 46.2959 14.1169 46.4527 13.9304L48.5147 12.0612V43.6041C48.5103 43.8237 48.4494 44.0385 48.3378 44.2278C48.2263 44.417 48.068 44.5744 47.878 44.6847L40.1093 49.457C39.6166 49.7569 39.0505 49.9146 38.4737 49.9126H19.5659M38.7376 45.7304V21.9565M24.5667 18.9128C24.4793 18.5295 24.4342 18.1377 24.4324 17.7446C24.4324 14.491 27.353 11.8507 30.9686 11.8507C34.5843 11.8507 37.5107 14.491 37.5107 17.7446M11.8247 17.727V4.48488C11.8247 2.66241 13.466 1.18457 15.4929 1.18457C17.514 1.18457 19.1553 2.66241 19.1553 4.48488V18.9128M14.3944 7.89028L15.492 7.21303M14.3944 11.1728L15.492 10.4955M14.3944 14.4557L15.492 13.7785M19.1573 18.9134V7.77993C19.1573 5.95745 20.7986 4.47377 22.8197 4.47377C24.8465 4.47377 26.4879 5.95745 26.4879 7.77993V13.4518M21.727 11.1849L22.8188 10.5077M21.727 14.462L22.8188 13.7847M46.3825 13.9769C46.2307 9.57255 43.7423 7.70919 40.6699 7.65077V4.8236H42.6267C42.8253 4.8236 42.9888 4.70678 42.9888 4.56075V2.22424C42.9888 1.64012 42.3405 1.16113 41.5402 1.16113H35.8217C35.0215 1.16113 34.3673 1.64012 34.3673 2.22424V4.56075C34.3673 4.70678 34.5309 4.8236 34.7353 4.8236H36.6921V7.64493C34.1045 7.64493 31.9023 8.90665 31.1255 11.8565M6.2146 21.7468H16.0453C16.2002 21.7468 16.3487 21.8083 16.4583 21.9179C16.5678 22.0274 16.6294 22.176 16.6294 22.3309V25.1347H5.63049V22.3309C5.63049 22.176 5.69203 22.0274 5.80157 21.9179C5.91111 21.8083 6.05969 21.7468 6.2146 21.7468Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Transport = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="56" height="31" viewBox="0 0 56 31" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.74088 5.22314H28.3659V12.7231H7.74088V5.22314ZM33.0534 12.7231H42.8643L37.8628 5.22314H33.0534V12.7231Z"
        fill="#DAD1FA"
      />
      <path d="M37.8483 24.5632H18.0014" stroke="#414141" strokeWidth="1.71429" strokeMiterlimit="10" />
      <path
        d="M6.85 24.5636H4.12656C3.49626 24.5636 2.89177 24.3132 2.44608 23.8675C2.00039 23.4218 1.75 22.8173 1.75 22.187V22.187C1.75 21.5567 2.00039 20.9522 2.44608 20.5065C2.89177 20.0608 3.49626 19.8104 4.12656 19.8104H8.49063"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path
        d="M47.3079 19.8054H51.8735C52.5038 19.8054 53.1083 20.0558 53.554 20.5015C53.9997 20.9472 54.2501 21.5517 54.2501 22.182V22.182C54.2501 22.8123 53.9997 23.4168 53.554 23.8625C53.1083 24.3082 52.5038 24.5585 51.8735 24.5585H49.0001"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path d="M16.3608 19.8054H39.4889" stroke="#414141" strokeWidth="1.71429" strokeMiterlimit="10" />
      <path
        d="M52.375 19.7535V16.0035C52.375 15.009 51.9799 14.0552 51.2767 13.3519C50.5734 12.6486 49.6196 12.2535 48.625 12.2535H47.7813L41.3922 2.67229C41.0499 2.15925 40.5864 1.73855 40.0426 1.44747C39.4989 1.15639 38.8917 1.00391 38.275 1.00354H7.375C6.38044 1.00354 5.42661 1.39863 4.72335 2.10189C4.02009 2.80515 3.625 3.75898 3.625 4.75354V19.7535"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path
        d="M43.4267 29.4471C46.5333 29.4471 49.0517 26.9287 49.0517 23.8221C49.0517 20.7155 46.5333 18.1971 43.4267 18.1971C40.3201 18.1971 37.8017 20.7155 37.8017 23.8221C37.8017 26.9287 40.3201 29.4471 43.4267 29.4471Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path
        d="M43.4267 25.6971C44.4622 25.6971 45.3017 24.8577 45.3017 23.8221C45.3017 22.7866 44.4622 21.9471 43.4267 21.9471C42.3912 21.9471 41.5517 22.7866 41.5517 23.8221C41.5517 24.8577 42.3912 25.6971 43.4267 25.6971Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4284 29.4471C15.535 29.4471 18.0534 26.9287 18.0534 23.8221C18.0534 20.7155 15.535 18.1971 12.4284 18.1971C9.32177 18.1971 6.80338 20.7155 6.80338 23.8221C6.80338 26.9287 9.32177 29.4471 12.4284 29.4471Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path
        d="M12.4284 25.6971C13.4639 25.6971 14.3034 24.8577 14.3034 23.8221C14.3034 22.7866 13.4639 21.9471 12.4284 21.9471C11.3928 21.9471 10.5534 22.7866 10.5534 23.8221C10.5534 24.8577 11.3928 25.6971 12.4284 25.6971Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeMiterlimit="10"
      />
      <path
        d="M42.8642 12.7223H33.0533V5.22229H37.8627L42.8642 12.7223Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinejoin="round"
      />
      <path
        d="M28.3658 5.22229H7.74078V12.7223H28.3658V5.22229Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinejoin="round"
      />
      <path d="M18.0533 5.22229V12.7223" stroke="#414141" strokeWidth="1.71429" strokeMiterlimit="10" />
    </svg>
  );
};

export const Health = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2793 37.0839H26.8612V6.66608L26.8615 6.66528H35.4262V42.4461H17.2659V37.1264L17.2793 37.0839Z"
        fill="#B1DBFF"
      />
      <path
        d="M20.821 17.0453H17.1227V13.3469H11.9937V17.0453H8.30066V22.1689H11.9937V25.8673H17.1227V22.1689H20.821V17.0453Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2954 10.6816H39.6521"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2954 15.3918H39.6521"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2954 24.8179H39.6521"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2954 29.5288H39.6521"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.2954 34.2388H39.6521"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8614 1.30347H1.42856V37.0842H26.8614V1.30347Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8615 6.66553H42.6987V42.4463H17.2659V37.1266"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.8615 37.0891L17.2659 42.4459"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/**
 * @param {Object} props
 * @param {number} [props.width=35]
 * @param {number} [props.height=44]
 *
 */
export function MoneyDocumentsIcon({ width = 35, height = 44 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 35 44" fill="none">
      <path
        d="M7.85742 4.54297V8.1144V8.47154L29.8217 8.91797V39.7215H31.8753L34.1074 6.15011L7.85742 4.54297Z"
        fill="#DAD1FA"
      />
      <path
        d="M3.53337 34.618L0.714844 34.4217L3.02511 0.714844L29.2428 2.50915L29.0272 5.63571M7.59263 8.51127L7.88912 4.18722L34.1068 5.98153L31.7965 39.6922L29.8213 39.5574M7.64286 31.0957H25.7053M7.64286 34.4397H25.7053M7.64286 37.7866H25.7053M16.6979 13.7697V15.3079M18.7857 16.9467C18.7857 16.9467 18.7857 15.3076 16.7001 15.3076C14.6145 15.3076 14.5595 17.4176 14.5595 17.4176C14.5595 17.4176 14.5595 19.5889 16.6665 19.5889C18.7826 19.5889 18.7765 21.7631 18.7765 21.7631C18.7765 21.7631 18.7765 23.8701 16.6359 23.8701C14.4952 23.8701 14.59 22.2341 14.59 22.2341M16.6979 23.869V25.4072M3.53292 8.51339H29.8122V42.3011H3.53292V8.51339Z"
        stroke="#414141"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const Education = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="54" height="39" viewBox="0 0 54 39" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9998 36.1228C22.0152 30.6994 12.8304 29.5568 6.14042 31.9275V9.80786H1.74359V37.5532C5.54275 35.4937 9.80196 34.431 14.1233 34.4641C23.0717 34.4641 26.9998 37.9985 26.9998 37.9985C26.9998 37.9985 30.8061 34.4641 39.8764 34.4641C44.1977 34.431 48.4569 35.4937 52.2561 37.5532V9.80786H47.8592V31.9275C41.1891 29.554 31.9574 30.6896 26.9998 36.1228Z"
        fill="#FFC9E4"
      />
      <path
        d="M1.74368 9.80762V37.5529C5.54285 35.4935 9.80205 34.4307 14.1234 34.4639C23.0718 34.4639 26.9999 37.9982 26.9999 37.9982C26.9999 37.9982 30.8062 34.4639 39.8765 34.4639C44.1978 34.4307 48.457 35.4935 52.2562 37.5529V9.80762"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.8593 31.928C47.8593 31.928 42.2343 29.9265 36.2296 31.2577C30.2249 32.589 26.9999 36.1234 26.9999 36.1234V6.5921C26.9999 6.5921 30.3233 3.42335 36.4687 2.14366C40.2921 1.40816 44.2465 1.78895 47.8593 3.24053V31.928Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.14053 31.928C6.14053 31.928 11.789 29.9265 17.7702 31.2577C23.7515 32.589 26.9999 36.1234 26.9999 36.1234V6.5921C26.9999 6.5921 23.6765 3.42335 17.5312 2.14366C13.7077 1.40816 9.75337 1.78895 6.14053 3.24053V31.928Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Connectivity = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="36" viewBox="0 0 52 36" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5082 5.29443H27.7147L24.7147 21.4616H18.3785V12.3584C18.3785 11.3229 17.5391 10.4834 16.5035 10.4834H10.5082V5.29443ZM46.1431 18.7576H40.5503V29.7826H44.0003L46.1431 18.7576ZM1.33011 29.7823H8.42895L11.4745 14.4166H1.33011V29.7823Z"
        fill="#DAD1FA"
      />
      <path
        d="M49.058 15.0078H41.9283C41.1517 15.0078 40.5221 15.6374 40.5221 16.4141V33.1344C40.5221 33.911 41.1517 34.5406 41.9283 34.5406H49.058C49.8347 34.5406 50.4643 33.911 50.4643 33.1344V16.4141C50.4643 15.6374 49.8347 15.0078 49.058 15.0078Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5501 18.7578H50.4408"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5501 29.7834H50.4408"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.4954 33.0598C45.3085 33.0591 45.126 33.0025 44.9715 32.8972C44.8169 32.792 44.6974 32.6429 44.6282 32.4692C44.5794 32.3569 44.5554 32.2354 44.5579 32.113C44.5595 31.9894 44.5834 31.8672 44.6282 31.752C44.6535 31.6975 44.6817 31.6443 44.7126 31.5927C44.7491 31.5422 44.7882 31.4937 44.8298 31.4473C44.872 31.4052 44.9282 31.3677 44.9704 31.3302C45.0231 31.2984 45.078 31.2702 45.1345 31.2458C45.19 31.2216 45.2482 31.2043 45.3079 31.1942C45.4282 31.1661 45.5533 31.1661 45.6736 31.1942C45.7348 31.2042 45.7946 31.2216 45.8517 31.2458C45.9076 31.2682 45.961 31.2965 46.0111 31.3302C46.0639 31.3654 46.114 31.4046 46.1611 31.4473L46.2782 31.5927C46.3076 31.6443 46.3342 31.6975 46.3579 31.752C46.3816 31.8097 46.4004 31.8693 46.4142 31.9302C46.419 31.991 46.419 32.0521 46.4142 32.113C46.4144 32.3605 46.3166 32.5981 46.1423 32.7739C46.0525 32.8597 45.9476 32.928 45.8329 32.9755C45.7267 33.0244 45.6122 33.053 45.4954 33.0598Z"
        fill="#414141"
      />
      <path
        d="M16.5033 10.4844H3.16272C2.12719 10.4844 1.28772 11.3238 1.28772 12.3594V32.6656C1.28772 33.7012 2.12719 34.5406 3.16272 34.5406H16.5033C17.5389 34.5406 18.3783 33.7012 18.3783 32.6656V12.3594C18.3783 11.3238 17.5389 10.4844 16.5033 10.4844Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3298 14.4167H18.3314"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.71902 29.7834H17.9425"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83303 33.0586C9.70932 33.0587 9.58682 33.0343 9.47257 32.9869C9.35833 32.9394 9.25462 32.8698 9.1674 32.7821C8.99307 32.6063 8.89533 32.3687 8.89553 32.1211C8.88626 32.0605 8.88626 31.9989 8.89553 31.9383C8.90174 31.8768 8.91756 31.8167 8.9424 31.7602C8.96561 31.7037 8.99552 31.6502 9.03147 31.6008C9.0653 31.5484 9.10458 31.4997 9.14865 31.4555C9.19238 31.4128 9.2394 31.3736 9.28928 31.3383C9.34147 31.3056 9.39635 31.2773 9.45334 31.2539C9.50945 31.2303 9.56748 31.2115 9.62678 31.1977C9.74747 31.1737 9.87171 31.1737 9.9924 31.1977C10.0517 31.2115 10.1097 31.2303 10.1658 31.2539C10.2233 31.2764 10.2783 31.3046 10.3299 31.3383L10.4752 31.4555C10.5179 31.5009 10.5571 31.5494 10.5924 31.6008C10.6251 31.6514 10.6533 31.7047 10.6768 31.7602C10.7004 31.8179 10.7192 31.8775 10.733 31.9383C10.7376 31.9992 10.7376 32.0603 10.733 32.1211C10.733 32.3698 10.6343 32.6082 10.4584 32.784C10.2826 32.9599 10.0442 33.0586 9.79553 33.0586H9.83303Z"
        fill="#414141"
      />
      <path
        d="M40.4236 25.5964H18.4017"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4236 21.4631H18.4017"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9597 5.29468H10.5081"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.222 10.3109V3.125C10.222 2.62772 10.4196 2.15081 10.7712 1.79918C11.1228 1.44754 11.5997 1.25 12.097 1.25H44.1455C44.6427 1.25 45.1197 1.44754 45.4713 1.79918C45.8229 2.15081 46.0205 2.62772 46.0205 3.125V15.0078"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.0642 25.6584L33.8845 30.4913H22.3626L23.183 25.7053"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Insurance = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="48" viewBox="0 0 37 48" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3228 46.2923C35.2263 39.374 35.7783 25.9377 35.7783 25.9377V8.41199C24.6156 6.91366 18.3282 1.73169 18.3282 1.73169C18.3282 1.73169 19.8675 6.92826 25.3079 10.7384V16.6686C27.7267 18.7186 29.262 21.779 29.262 25.1981C29.262 28.8089 27.5496 32.0198 24.8926 34.0629C24.026 39.963 21.811 43.2524 18.3228 46.2923Z"
        fill="#B1DBFF"
      />
      <path
        d="M18.3234 46.2925C35.227 39.3742 35.779 25.9379 35.779 25.9379V8.41224C24.6163 6.9139 18.3289 1.73193 18.3289 1.73193C18.3289 1.73193 12.0198 6.93013 0.857117 8.42306V25.9487C0.857117 25.9487 1.39821 39.3905 18.3126 46.3034"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0864 36.3743C24.2587 36.3743 29.2624 31.3707 29.2624 25.1984C29.2624 19.0261 24.2587 14.0225 18.0864 14.0225C11.9141 14.0225 6.91049 19.0261 6.91049 25.1984C6.91049 31.3707 11.9141 36.3743 18.0864 36.3743Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.108 18.9673V20.5847"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0863 25.0797C15.863 25.0797 15.8684 22.7969 15.8684 22.7969C15.8684 22.7969 15.8684 20.5845 18.108 20.5845C20.3475 20.5845 20.2717 22.3047 20.2717 22.3047"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8737 27.8336C15.8737 27.8336 15.8737 29.5538 18.0374 29.5538C20.2012 29.5538 20.2715 27.3414 20.2715 27.3414C20.2715 27.3414 20.2715 25.0586 18.0591 25.0586"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.108 29.5752V31.1926"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PriceTag = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="61" viewBox="0 0 42 61" fill="none">
      <path
        d="M11.2346 23.7173L11.2346 49.0952L33.1079 49.0952L29.8317 59.4571L1.634 50.0105L11.2346 23.7173Z"
        fill="#FFC9E4"
      />
      <path
        d="M11.1385 23.3699L1.49673 49.9569L29.1061 59.9685L33.0487 49.0923M16.3059 44.3829H35.3393M16.3059 39.4887H35.3393M26.0391 12.1023C26.2621 13.4129 26.0391 14.5331 25.3267 15.2564C23.5104 17.0673 19.2034 15.7023 15.7013 12.2002C12.1991 8.698 10.8069 4.38557 12.645 2.57467C14.3635 0.856223 18.3387 2.03086 21.7376 5.12515M25.6039 22.6522V24.3815M25.6039 24.3815C27.9423 24.3815 27.9423 26.2142 27.9423 26.2142M25.6039 24.3815C23.2655 24.3815 23.2166 26.7417 23.2166 26.7417C23.2166 26.7417 23.2112 29.1562 25.5822 29.1562M23.2233 32.142C23.2233 32.142 23.2233 33.9801 25.5617 33.9801C27.9001 33.9801 27.9762 31.6145 27.9762 31.6145C27.9762 31.6145 27.9762 29.1565 25.5834 29.1565M25.6039 33.98V35.7039M33.9237 5.58716H17.718L11.1379 14.2882V49.0922H40.5038V14.2718L33.9237 5.58716ZM28.845 15.3544C28.845 17.1564 27.3842 18.6172 25.5822 18.6172C23.7801 18.6172 22.3193 17.1564 22.3193 15.3544C22.3193 13.5523 23.7801 12.0915 25.5822 12.0915C27.3842 12.0915 28.845 13.5523 28.845 15.3544Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const HouseBlue = ({ width = '42', height = '38' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3707 13.8438V24.3327C23.3707 24.4718 23.3155 24.6052 23.2171 24.7035C23.1188 24.8019 22.9854 24.8571 22.8463 24.8571H7.50882C7.36973 24.8571 7.23634 24.8019 7.13798 24.7035C7.03963 24.6052 6.98438 24.4718 6.98438 24.3327V13.8438"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8044 14.7578H12.5547V20.0075H17.8044V14.7578Z"
        fill="#B1DBFF"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5547 17.3828H17.8044"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1797 14.7578V20.0101"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9302 13.0395L15.2507 4.28125L15.1799 4.37565L15.1091 4.28125L3.42969 13.0395L5.00565 15.1399L15.1799 7.50922L25.3542 15.1399L26.9302 13.0395Z"
        fill="#B1DBFF"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3756 10.3748V6.25H20.6406V8.32419"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const House = ({ width = '49', height = '44' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 49 44" fill="none">
      <path
        d="M40.736 20.5623V41.5401C40.736 41.8183 40.6255 42.0851 40.4288 42.2818C40.2321 42.4785 39.9653 42.589 39.6871 42.589H9.01218C8.734 42.589 8.46721 42.4785 8.2705 42.2818C8.0738 42.0851 7.96329 41.8183 7.96329 41.5401V20.5623"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6072 22.4067H19.1078V32.9062H29.6072V22.4067Z"
        fill="#DAD1FA"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1078 27.6567H29.6072"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3573 22.4067V32.9114"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.8581 18.9621L24.4992 1.44556L24.3576 1.63436L24.216 1.44556L0.857117 18.9621L4.00904 23.1629L24.3576 7.9015L44.7061 23.1629L47.8581 18.9621Z"
        fill="#DAD1FA"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.7467 13.6343V5.38477H35.2768V9.53314"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Coins = ({ width = '48', height = '48', color = '#0156F5' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
      <path
        opacity="0.2"
        d="M45 24.75C45 28.4775 38.2838 31.5 30 31.5C26.325 31.5 22.9575 30.9056 20.3494 29.9175C27.5175 29.4094 33 26.625 33 23.25V18.135C39.8475 18.7613 45 21.4837 45 24.75ZM33 15.75C33 12.0225 26.2838 9 18 9C9.71625 9 3 12.0225 3 15.75C3 19.4775 9.71625 22.5 18 22.5C26.2838 22.5 33 19.4775 33 15.75Z"
        fill={color}
      />
      <path
        d="M34.5 16.7944V15.75C34.5 11.0475 27.4069 7.5 18 7.5C8.59313 7.5 1.5 11.0475 1.5 15.75V23.25C1.5 27.1669 6.42188 30.2794 13.5 31.2113V32.25C13.5 36.9525 20.5931 40.5 30 40.5C39.4069 40.5 46.5 36.9525 46.5 32.25V24.75C46.5 20.8687 41.7338 17.7525 34.5 16.7944ZM43.5 24.75C43.5 27.2288 37.7269 30 30 30C29.3006 30 28.6069 29.9756 27.9225 29.9306C31.9669 28.4569 34.5 26.0625 34.5 23.25V19.8262C40.1006 20.6606 43.5 22.9256 43.5 24.75ZM13.5 28.1719V23.7112C14.9921 23.9057 16.4953 24.0021 18 24C19.5047 24.0021 21.0079 23.9057 22.5 23.7112V28.1719C21.0101 28.392 19.506 28.5016 18 28.5C16.494 28.5016 14.9899 28.392 13.5 28.1719ZM31.5 20.6119V23.25C31.5 24.8231 29.1731 26.5125 25.5 27.5381V23.1562C27.9206 22.5694 29.97 21.6956 31.5 20.6119ZM18 10.5C25.7269 10.5 31.5 13.2712 31.5 15.75C31.5 18.2288 25.7269 21 18 21C10.2731 21 4.5 18.2288 4.5 15.75C4.5 13.2712 10.2731 10.5 18 10.5ZM4.5 23.25V20.6119C6.03 21.6956 8.07938 22.5694 10.5 23.1562V27.5381C6.82687 26.5125 4.5 24.8231 4.5 23.25ZM16.5 32.25V31.4681C16.9931 31.4869 17.4919 31.5 18 31.5C18.7275 31.5 19.4381 31.4756 20.1356 31.4344C20.9105 31.7118 21.6998 31.9471 22.5 32.1394V36.5381C18.8269 35.5125 16.5 33.8231 16.5 32.25ZM25.5 37.1719V32.7C26.9916 32.9005 28.495 33.0007 30 33C31.5047 33.0021 33.0079 32.9057 34.5 32.7113V37.1719C31.5159 37.6094 28.4841 37.6094 25.5 37.1719ZM37.5 36.5381V32.1562C39.9206 31.5694 41.97 30.6956 43.5 29.6119V32.25C43.5 33.8231 41.1731 35.5125 37.5 36.5381Z"
        fill={color}
      />
    </svg>
  );
};

const FigmaExpenseIcon = ({ width = '48', height = '48', children }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
    {children}
  </svg>
);

export const HouseLine = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M33 15.8806V34.5012H21V22.5012H12V34.5012H0V15.8806L15.4387 0.43993C15.5781 0.300465 15.7435 0.189827 15.9256 0.11434C16.1077 0.038854 16.3029 0 16.5 0C16.6971 0 16.8923 0.038854 17.0744 0.11434C17.2565 0.189827 17.4219 0.300465 17.5613 0.43993L33 15.8806Z"
      fill={color}
      transform="translate(7.5024 6)"
    />
    <path
      d="M43.5 34.5005H40.5V21.0005L40.9387 21.4392C41.2207 21.7207 41.6029 21.8786 42.0013 21.8783C42.3997 21.8779 42.7817 21.7193 43.0631 21.4374C43.3446 21.1554 43.5025 20.7732 43.5022 20.3748C43.5018 19.9764 43.3432 19.5944 43.0613 19.313L24.6206 0.877985C24.0581 0.315801 23.2953 0 22.5 0C21.7047 0 20.9419 0.315801 20.3794 0.877985L1.93875 19.313C1.65754 19.5944 1.49965 19.9761 1.49983 20.374C1.5 20.7718 1.65823 21.1533 1.93969 21.4345C2.22115 21.7158 2.60279 21.8736 3.00066 21.8735C3.39853 21.8733 3.78004 21.7151 4.06125 21.4336L4.5 21.0005V34.5005H1.5C1.10218 34.5005 0.720644 34.6585 0.43934 34.9398C0.158035 35.2211 0 35.6027 0 36.0005C0 36.3983 0.158035 36.7798 0.43934 37.0611C0.720644 37.3424 1.10218 37.5005 1.5 37.5005H43.5C43.8978 37.5005 44.2794 37.3424 44.5607 37.0611C44.842 36.7798 45 36.3983 45 36.0005C45 35.6027 44.842 35.2211 44.5607 34.9398C44.2794 34.6585 43.8978 34.5005 43.5 34.5005ZM7.5 18.0005L22.5 3.00048L37.5 18.0005V34.5005H28.5V24.0005C28.5 23.6027 28.342 23.2211 28.0607 22.9398C27.7794 22.6585 27.3978 22.5005 27 22.5005H18C17.6022 22.5005 17.2206 22.6585 16.9393 22.9398C16.658 23.2211 16.5 23.6027 16.5 24.0005V34.5005H7.5V18.0005ZM25.5 34.5005H19.5V25.5005H25.5V34.5005Z"
      fill={color}
      transform="translate(1.5024 4.4976)"
    />
  </FigmaExpenseIcon>
);

export const Lightbulb = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M30.0002 15.0044C30.0022 17.2772 29.4868 19.5206 28.4931 21.5646C27.4993 23.6087 26.0533 25.3997 24.2646 26.8019C23.7184 27.2252 23.2756 27.7674 22.9699 28.3872C22.6642 29.007 22.5036 29.6883 22.5002 30.3794V31.5044C22.5002 31.9022 22.3422 32.2837 22.0609 32.565C21.7796 32.8463 21.3981 33.0044 21.0002 33.0044H9.00023C8.60241 33.0044 8.22087 32.8463 7.93957 32.565C7.65827 32.2837 7.50023 31.9022 7.50023 31.5044V30.3794C7.49951 29.6921 7.34209 29.014 7.03993 28.3967C6.73777 27.7793 6.29883 27.239 5.75648 26.8169C3.9733 25.4239 2.52898 23.6449 1.532 21.6136C0.535024 19.5823 0.0113195 17.3515 0.000230313 15.0887C-0.0447697 6.95874 6.51023 0.191866 14.6384 0.00436606C16.6384 -0.0438997 18.6279 0.308427 20.4898 1.04061C22.3517 1.77279 24.0482 2.87003 25.4797 4.26774C26.9111 5.66546 28.0485 7.3354 28.8248 9.17928C29.6012 11.0232 30.0008 13.0037 30.0002 15.0044Z"
      fill={color}
      transform="translate(9 4.4976)"
    />
    <path
      d="M25.5002 40.5048C25.5002 40.9026 25.3422 41.2841 25.0609 41.5655C24.7796 41.8468 24.3981 42.0048 24.0002 42.0048H9.00025C8.60242 42.0048 8.22089 41.8468 7.93959 41.5655C7.65828 41.2841 7.50025 40.9026 7.50025 40.5048C7.50025 40.107 7.65828 39.7254 7.93959 39.4441C8.22089 39.1628 8.60242 39.0048 9.00025 39.0048H24.0002C24.3981 39.0048 24.7796 39.1628 25.0609 39.4441C25.3422 39.7254 25.5002 40.107 25.5002 40.5048ZM33.0002 16.5048C33.0067 19.0054 32.4418 21.4744 31.3487 23.7234C30.2555 25.9724 28.663 27.9419 26.6927 29.4817C26.3243 29.7641 26.0254 30.1269 25.8187 30.5426C25.612 30.9582 25.5031 31.4156 25.5002 31.8798V33.0048C25.5002 33.8004 25.1842 34.5635 24.6216 35.1261C24.059 35.6887 23.2959 36.0048 22.5002 36.0048H10.5002C9.7046 36.0048 8.94153 35.6887 8.37893 35.1261C7.81632 34.5635 7.50025 33.8004 7.50025 33.0048V31.8798C7.49994 31.4212 7.39448 30.9687 7.19198 30.5572C6.98948 30.1457 6.69532 29.7861 6.33212 29.506C4.36675 27.9754 2.77533 26.0177 1.67833 23.7811C0.581328 21.5446 0.00748832 19.0878 0.000245343 16.5967C-0.0485047 7.66041 7.174 0.218539 16.1027 0.0047891C18.3028 -0.0482271 20.4912 0.339389 22.5392 1.14482C24.5871 1.95026 26.4533 3.15723 28.0278 4.69471C29.6023 6.23219 30.8534 8.0691 31.7073 10.0973C32.5613 12.1256 33.0009 14.3041 33.0002 16.5048ZM30.0002 16.5048C30.0008 14.7042 29.6411 12.9216 28.9423 11.2621C28.2436 9.60255 27.2199 8.09957 25.9315 6.84162C24.6432 5.58367 23.1162 4.59617 21.4405 3.93724C19.7647 3.27831 17.9741 2.96127 16.174 3.00479C8.8615 3.17729 2.96087 9.26541 3.00025 16.5779C3.0071 18.6153 3.47724 20.6244 4.37509 22.4532C5.27295 24.2821 6.57501 25.8828 8.18275 27.1342C8.90545 27.696 9.49003 28.4157 9.89172 29.2383C10.2934 30.0608 10.5016 30.9644 10.5002 31.8798V33.0048H22.5002V31.8798C22.5023 30.9618 22.714 30.0564 23.1193 29.2327C23.5245 28.4089 24.1125 27.6886 24.8384 27.1267C26.4511 25.8664 27.7544 24.2542 28.6491 22.4133C29.5437 20.5725 30.0058 18.5515 30.0002 16.5048ZM26.9796 14.7535C26.5907 12.581 25.5454 10.5797 23.9846 9.01922C22.4237 7.45873 20.4223 6.4139 18.2496 6.02541C18.0553 5.99267 17.8565 5.9985 17.6645 6.04259C17.4725 6.08668 17.291 6.16816 17.1305 6.28238C16.97 6.3966 16.8335 6.54131 16.7289 6.70827C16.6243 6.87522 16.5536 7.06114 16.5209 7.25541C16.4881 7.44969 16.494 7.64851 16.538 7.84053C16.5821 8.03255 16.6636 8.214 16.7778 8.37453C16.892 8.53506 17.0368 8.67152 17.2037 8.77612C17.3707 8.88072 17.5566 8.95142 17.7509 8.98416C20.8577 9.50729 23.494 12.1435 24.0209 15.256C24.0802 15.6054 24.2613 15.9225 24.5321 16.151C24.8029 16.3796 25.1459 16.5049 25.5002 16.5048C25.585 16.5043 25.6696 16.4974 25.7534 16.4842C26.1455 16.4172 26.4949 16.1973 26.7248 15.8728C26.9548 15.5482 27.0464 15.1456 26.9796 14.7535Z"
      fill={color}
      transform="translate(7.4976 2.9952)"
    />
  </FigmaExpenseIcon>
);

export const ShoppingCart = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M31.5 0L29.22 12.5363C29.0944 13.2275 28.7302 13.8527 28.1909 14.303C27.6516 14.7532 26.9713 14.9999 26.2688 15H2.72813L0 0H31.5Z"
      fill={color}
      transform="translate(10.5024 12)"
    />
    <path
      d="M40.1512 8.03812C40.0104 7.86963 39.8344 7.73411 39.6354 7.64112C39.4365 7.54814 39.2196 7.49996 39 7.5H8.7525L7.6125 1.23187C7.54971 0.886252 7.36761 0.573628 7.09794 0.348508C6.82828 0.123388 6.48816 5.07697e-05 6.13687 0H1.5C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5C0 1.89782 0.158035 2.27936 0.43934 2.56066C0.720644 2.84196 1.10218 3 1.5 3H4.875L9.6675 29.3044C9.80867 30.0845 10.1534 30.8135 10.6669 31.4175C9.95821 32.0794 9.44672 32.9247 9.18911 33.8595C8.9315 34.7944 8.93784 35.7823 9.20743 36.7138C9.47702 37.6453 9.99932 38.4839 10.7164 39.1366C11.4335 39.7894 12.3174 40.2308 13.27 40.4119C14.2227 40.5929 15.2069 40.5067 16.1135 40.1625C17.0201 39.8184 17.8136 39.23 18.4062 38.4624C18.9988 37.6948 19.3672 36.7781 19.4705 35.8139C19.5739 34.8497 19.4082 33.8758 18.9919 33H27.5081C27.1725 33.7025 26.9989 34.4714 27 35.25C27 36.2884 27.3079 37.3034 27.8848 38.1667C28.4617 39.0301 29.2816 39.703 30.2409 40.1004C31.2002 40.4977 32.2558 40.6017 33.2742 40.3991C34.2926 40.1966 35.2281 39.6965 35.9623 38.9623C36.6965 38.2281 37.1966 37.2926 37.3991 36.2742C37.6017 35.2558 37.4977 34.2002 37.1004 33.2409C36.703 32.2816 36.0301 31.4617 35.1667 30.8848C34.3034 30.3079 33.2884 30 32.25 30H14.0944C13.7431 29.9999 13.403 29.8766 13.1333 29.6515C12.8636 29.4264 12.6815 29.1137 12.6188 28.7681L12.0244 25.5H33.7744C34.8282 25.4998 35.8486 25.1298 36.6576 24.4545C37.4666 23.7791 38.0129 22.8412 38.2013 21.8044L40.4812 9.26813C40.5198 9.05145 40.5103 8.82893 40.4533 8.61637C40.3962 8.4038 40.2931 8.20638 40.1512 8.03812ZM16.5 35.25C16.5 35.695 16.368 36.13 16.1208 36.5C15.8736 36.87 15.5222 37.1584 15.111 37.3287C14.6999 37.499 14.2475 37.5436 13.811 37.4568C13.3746 37.37 12.9737 37.1557 12.659 36.841C12.3443 36.5263 12.13 36.1254 12.0432 35.689C11.9564 35.2525 12.001 34.8001 12.1713 34.389C12.3416 33.9778 12.63 33.6264 13 33.3792C13.37 33.132 13.805 33 14.25 33C14.8467 33 15.419 33.2371 15.841 33.659C16.2629 34.081 16.5 34.6533 16.5 35.25ZM34.5 35.25C34.5 35.695 34.368 36.13 34.1208 36.5C33.8736 36.87 33.5222 37.1584 33.111 37.3287C32.6999 37.499 32.2475 37.5436 31.811 37.4568C31.3746 37.37 30.9737 37.1557 30.659 36.841C30.3443 36.5263 30.13 36.1254 30.0432 35.689C29.9564 35.2525 30.001 34.8001 30.1713 34.389C30.3416 33.9778 30.63 33.6264 31 33.3792C31.37 33.132 31.805 33 32.25 33C32.8467 33 33.419 33.2371 33.841 33.659C34.2629 34.081 34.5 34.6533 34.5 35.25ZM35.25 21.2681C35.187 21.6147 35.0041 21.9281 34.7333 22.1533C34.4625 22.3785 34.121 22.5013 33.7688 22.5H11.4788L9.29812 10.5H37.2019L35.25 21.2681Z"
      fill={color}
      transform="translate(3 3)"
    />
  </FigmaExpenseIcon>
);

export const Van = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M42 0V12C42 12.3978 41.842 12.7794 41.5607 13.0607C41.2794 13.342 40.8978 13.5 40.5 13.5H36C36 12.3065 35.5259 11.1619 34.682 10.318C33.8381 9.47411 32.6935 9 31.5 9C30.3065 9 29.1619 9.47411 28.318 10.318C27.4741 11.1619 27 12.3065 27 13.5H15C15 12.3065 14.5259 11.1619 13.682 10.318C12.8381 9.47411 11.6935 9 10.5 9C9.30653 9 8.16193 9.47411 7.31802 10.318C6.47411 11.1619 6 12.3065 6 13.5H1.5C1.10218 13.5 0.720644 13.342 0.43934 13.0607C0.158035 12.7794 0 12.3978 0 12V0H42Z"
      fill={color}
      transform="translate(4.5024 21)"
    />
    <path
      d="M44.6381 11.0231L36.0994 1.07437C35.8178 0.73797 35.4658 0.467419 35.0683 0.28179C34.6708 0.0961608 34.2375 -2.8821e-05 33.7987 6.47765e-09H3C2.20435 6.47765e-09 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V24C0 24.7956 0.31607 25.5587 0.87868 26.1213C1.44129 26.6839 2.20435 27 3 27H6.1875C6.51795 28.2906 7.26855 29.4346 8.32097 30.2515C9.37338 31.0684 10.6677 31.5118 12 31.5118C13.3323 31.5118 14.6266 31.0684 15.679 30.2515C16.7314 29.4346 17.482 28.2906 17.8125 27H27.1875C27.518 28.2906 28.2686 29.4346 29.321 30.2515C30.3734 31.0684 31.6677 31.5118 33 31.5118C34.3323 31.5118 35.6266 31.0684 36.679 30.2515C37.7314 29.4346 38.482 28.2906 38.8125 27H42C42.7956 27 43.5587 26.6839 44.1213 26.1213C44.6839 25.5587 45 24.7956 45 24V12C45 11.6416 44.8716 11.2951 44.6381 11.0231ZM40.2356 10.5H30V3H33.7987L40.2356 10.5ZM16.5 10.5V3H27V10.5H16.5ZM13.5 3V10.5H3V3H13.5ZM12 28.5C11.4067 28.5 10.8266 28.3241 10.3333 27.9944C9.83994 27.6648 9.45542 27.1962 9.22836 26.6481C9.0013 26.0999 8.94189 25.4967 9.05764 24.9147C9.1734 24.3328 9.45912 23.7982 9.87868 23.3787C10.2982 22.9591 10.8328 22.6734 11.4147 22.5576C11.9967 22.4419 12.5999 22.5013 13.148 22.7284C13.6962 22.9554 14.1648 23.3399 14.4944 23.8333C14.8241 24.3266 15 24.9067 15 25.5C15 26.2956 14.6839 27.0587 14.1213 27.6213C13.5587 28.1839 12.7956 28.5 12 28.5ZM33 28.5C32.4067 28.5 31.8266 28.3241 31.3333 27.9944C30.8399 27.6648 30.4554 27.1962 30.2284 26.6481C30.0013 26.0999 29.9419 25.4967 30.0576 24.9147C30.1734 24.3328 30.4591 23.7982 30.8787 23.3787C31.2982 22.9591 31.8328 22.6734 32.4147 22.5576C32.9967 22.4419 33.5999 22.5013 34.1481 22.7284C34.6962 22.9554 35.1648 23.3399 35.4944 23.8333C35.8241 24.3266 36 24.9067 36 25.5C36 26.2956 35.6839 27.0587 35.1213 27.6213C34.5587 28.1839 33.7956 28.5 33 28.5ZM38.8125 24C38.482 22.7094 37.7314 21.5654 36.679 20.7485C35.6266 19.9316 34.3323 19.4882 33 19.4882C31.6677 19.4882 30.3734 19.9316 29.321 20.7485C28.2686 21.5654 27.518 22.7094 27.1875 24H17.8125C17.482 22.7094 16.7314 21.5654 15.679 20.7485C14.6266 19.9316 13.3323 19.4882 12 19.4882C10.6677 19.4882 9.37338 19.9316 8.32097 20.7485C7.26855 21.5654 6.51795 22.7094 6.1875 24H3V13.5H42V24H38.8125Z"
      fill={color}
      transform="translate(3 9)"
    />
  </FigmaExpenseIcon>
);

export const Heartbeat = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M39 10.125C39 22.5 19.5 33 19.5 33C19.5 33 0 22.5 0 10.125C0 7.43968 1.06674 4.86435 2.96554 2.96554C4.86435 1.06674 7.43968 0 10.125 0C14.3606 0 17.9887 2.30812 19.5 6C21.0113 2.30812 24.6394 0 28.875 0C31.5603 0 34.1356 1.06674 36.0345 2.96554C37.9333 4.86435 39 7.43968 39 10.125Z"
      fill={color}
      transform="translate(4.5024 9)"
    />
    <path
      d="M10.5 19.5H3C2.60218 19.5 2.22064 19.342 1.93934 19.0607C1.65804 18.7794 1.5 18.3978 1.5 18C1.5 17.6022 1.65804 17.2206 1.93934 16.9393C2.22064 16.658 2.60218 16.5 3 16.5H9.6975L12.2512 12.6675C12.3882 12.4617 12.5738 12.293 12.7917 12.1763C13.0095 12.0596 13.2529 11.9985 13.5 11.9985C13.7471 11.9985 13.9905 12.0596 14.2083 12.1763C14.4262 12.293 14.6118 12.4617 14.7488 12.6675L19.5 19.7925L21.2512 17.1675C21.3883 16.962 21.5741 16.7936 21.7919 16.6771C22.0098 16.5607 22.253 16.4998 22.5 16.5H27C27.3978 16.5 27.7794 16.658 28.0607 16.9393C28.342 17.2206 28.5 17.6022 28.5 18C28.5 18.3978 28.342 18.7794 28.0607 19.0607C27.7794 19.342 27.3978 19.5 27 19.5H23.3025L20.7488 23.3325C20.6118 23.5382 20.4262 23.707 20.2083 23.8237C19.9905 23.9404 19.7471 24.0015 19.5 24.0015C19.2529 24.0015 19.0095 23.9404 18.7917 23.8237C18.5738 23.707 18.3882 23.5382 18.2512 23.3325L13.5 16.2037L11.7488 18.8287C11.6121 19.0349 11.4266 19.2041 11.2087 19.3212C10.9908 19.4383 10.7474 19.4997 10.5 19.5ZM30.375 0C26.5031 0 23.1131 1.665 21 4.47937C18.8869 1.665 15.4969 0 11.625 0C8.54292 0.00347388 5.58808 1.22936 3.40872 3.40872C1.22936 5.58808 0.00347388 8.54292 0 11.625C0 11.7656 0 11.9062 0 12.0469C0.012432 12.4447 0.18239 12.8213 0.472485 13.0938C0.762581 13.3663 1.14905 13.5124 1.54688 13.5C1.9447 13.4876 2.32129 13.3176 2.59381 13.0275C2.86632 12.7374 3.01243 12.3509 3 11.9531C3 11.8444 3 11.7337 3 11.625C3.00298 9.33842 3.91264 7.14635 5.52949 5.52949C7.14635 3.91264 9.33842 3.00298 11.625 3C15.2719 3 18.3337 4.9425 19.6125 8.0625C19.7255 8.33762 19.9178 8.57293 20.1648 8.73853C20.4119 8.90413 20.7026 8.99255 21 8.99255C21.2974 8.99255 21.5881 8.90413 21.8352 8.73853C22.0822 8.57293 22.2745 8.33762 22.3875 8.0625C23.6662 4.93687 26.7281 3 30.375 3C32.6616 3.00298 34.8537 3.91264 36.4705 5.52949C38.0874 7.14635 38.997 9.33842 39 11.625C39 21.6769 24.42 30.7781 21 32.775C18.9694 31.5919 13.0069 27.9 8.4975 22.9856C8.36429 22.8403 8.20377 22.7227 8.02511 22.6395C7.84644 22.5563 7.65313 22.509 7.45622 22.5005C7.2593 22.492 7.06263 22.5223 6.87743 22.5898C6.69224 22.6572 6.52215 22.7605 6.37687 22.8937C6.2316 23.027 6.11399 23.1875 6.03075 23.3661C5.94751 23.5448 5.90027 23.7381 5.89174 23.935C5.88321 24.132 5.91355 24.3286 5.98102 24.5138C6.0485 24.699 6.15179 24.8691 6.285 25.0144C12.1294 31.3894 19.9594 35.6419 20.2894 35.82C20.5078 35.9375 20.752 35.999 21 35.999C21.248 35.999 21.4922 35.9375 21.7106 35.82C22.5394 35.3737 42 24.75 42 11.625C41.9965 8.54292 40.7706 5.58808 38.5913 3.40872C36.4119 1.22936 33.4571 0.00347388 30.375 0Z"
      fill={color}
      transform="translate(3 7.5024)"
    />
  </FigmaExpenseIcon>
);

export const BookOpenText = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M19.5 0V27H6C4.4087 27 2.88258 27.6321 1.75736 28.7574C0.632142 29.8826 0 31.4087 0 33V6C0 4.4087 0.632142 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0H19.5Z"
      fill={color}
      transform="translate(24 10.5024)"
    />
    <path
      d="M40.5 0H27C25.8357 0 24.6873 0.271088 23.6459 0.791796C22.6045 1.3125 21.6986 2.06853 21 3C20.3014 2.06853 19.3955 1.3125 18.3541 0.791796C17.3127 0.271088 16.1643 0 15 0H1.5C1.10218 0 0.720644 0.158036 0.43934 0.43934C0.158035 0.720645 0 1.10218 0 1.5V28.5C0 28.8978 0.158035 29.2794 0.43934 29.5607C0.720644 29.842 1.10218 30 1.5 30H15C16.1935 30 17.3381 30.4741 18.182 31.318C19.0259 32.1619 19.5 33.3065 19.5 34.5C19.5 34.8978 19.658 35.2794 19.9393 35.5607C20.2206 35.842 20.6022 36 21 36C21.3978 36 21.7794 35.842 22.0607 35.5607C22.342 35.2794 22.5 34.8978 22.5 34.5C22.5 33.3065 22.9741 32.1619 23.818 31.318C24.6619 30.4741 25.8065 30 27 30H40.5C40.8978 30 41.2794 29.842 41.5607 29.5607C41.842 29.2794 42 28.8978 42 28.5V1.5C42 1.10218 41.842 0.720645 41.5607 0.43934C41.2794 0.158036 40.8978 0 40.5 0ZM15 27H3V3H15C16.1935 3 17.3381 3.47411 18.182 4.31802C19.0259 5.16193 19.5 6.30653 19.5 7.5V28.5C18.203 27.524 16.6232 26.9974 15 27ZM39 27H27C25.3768 26.9974 23.797 27.524 22.5 28.5V7.5C22.5 6.30653 22.9741 5.16193 23.818 4.31802C24.6619 3.47411 25.8065 3 27 3H39V27ZM27 7.5H34.5C34.8978 7.5 35.2794 7.65804 35.5607 7.93934C35.842 8.22064 36 8.60218 36 9C36 9.39782 35.842 9.77936 35.5607 10.0607C35.2794 10.342 34.8978 10.5 34.5 10.5H27C26.6022 10.5 26.2206 10.342 25.9393 10.0607C25.658 9.77936 25.5 9.39782 25.5 9C25.5 8.60218 25.658 8.22064 25.9393 7.93934C26.2206 7.65804 26.6022 7.5 27 7.5ZM36 15C36 15.3978 35.842 15.7794 35.5607 16.0607C35.2794 16.342 34.8978 16.5 34.5 16.5H27C26.6022 16.5 26.2206 16.342 25.9393 16.0607C25.658 15.7794 25.5 15.3978 25.5 15C25.5 14.6022 25.658 14.2206 25.9393 13.9393C26.2206 13.658 26.6022 13.5 27 13.5H34.5C34.8978 13.5 35.2794 13.658 35.5607 13.9393C35.842 14.2206 36 14.6022 36 15ZM36 21C36 21.3978 35.842 21.7794 35.5607 22.0607C35.2794 22.342 34.8978 22.5 34.5 22.5H27C26.6022 22.5 26.2206 22.342 25.9393 22.0607C25.658 21.7794 25.5 21.3978 25.5 21C25.5 20.6022 25.658 20.2206 25.9393 19.9393C26.2206 19.658 26.6022 19.5 27 19.5H34.5C34.8978 19.5 35.2794 19.658 35.5607 19.9393C35.842 20.2206 36 20.6022 36 21Z"
      fill={color}
      transform="translate(3 9)"
    />
  </FigmaExpenseIcon>
);

export const Devices = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M33 3V6H28.5C27.7044 6 26.9413 6.31607 26.3787 6.87868C25.8161 7.44129 25.5 8.20435 25.5 9V24H3C2.20435 24 1.44129 23.6839 0.87868 23.1213C0.31607 22.5587 0 21.7956 0 21V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H30C30.7956 0 31.5587 0.31607 32.1213 0.87868C32.6839 1.44129 33 2.20435 33 3Z"
      fill={color}
      transform="translate(4.5024 9)"
    />
    <path
      d="M39 6H36V4.5C36 3.30653 35.5259 2.16193 34.682 1.31802C33.8381 0.474106 32.6935 0 31.5 0H4.5C3.30653 0 2.16193 0.474106 1.31802 1.31802C0.474106 2.16193 0 3.30653 0 4.5V22.5C0 23.6935 0.474106 24.8381 1.31802 25.682C2.16193 26.5259 3.30653 27 4.5 27H25.5V28.5C25.5 29.6935 25.9741 30.8381 26.818 31.682C27.6619 32.5259 28.8065 33 30 33H39C40.1935 33 41.3381 32.5259 42.182 31.682C43.0259 30.8381 43.5 29.6935 43.5 28.5V10.5C43.5 9.30653 43.0259 8.16193 42.182 7.31802C41.3381 6.47411 40.1935 6 39 6ZM4.5 24C4.10218 24 3.72064 23.842 3.43934 23.5607C3.15804 23.2794 3 22.8978 3 22.5V4.5C3 4.10218 3.15804 3.72064 3.43934 3.43934C3.72064 3.15804 4.10218 3 4.5 3H31.5C31.8978 3 32.2794 3.15804 32.5607 3.43934C32.842 3.72064 33 4.10218 33 4.5V6H30C28.8065 6 27.6619 6.47411 26.818 7.31802C25.9741 8.16193 25.5 9.30653 25.5 10.5V24H4.5ZM40.5 28.5C40.5 28.8978 40.342 29.2794 40.0607 29.5607C39.7794 29.842 39.3978 30 39 30H30C29.6022 30 29.2206 29.842 28.9393 29.5607C28.658 29.2794 28.5 28.8978 28.5 28.5V10.5C28.5 10.1022 28.658 9.72064 28.9393 9.43934C29.2206 9.15804 29.6022 9 30 9H39C39.3978 9 39.7794 9.15804 40.0607 9.43934C40.342 9.72064 40.5 10.1022 40.5 10.5V28.5ZM22.5 31.5C22.5 31.8978 22.342 32.2794 22.0607 32.5607C21.7794 32.842 21.3978 33 21 33H13.5C13.1022 33 12.7206 32.842 12.4393 32.5607C12.158 32.2794 12 31.8978 12 31.5C12 31.1022 12.158 30.7206 12.4393 30.4393C12.7206 30.158 13.1022 30 13.5 30H21C21.3978 30 21.7794 30.158 22.0607 30.4393C22.342 30.7206 22.5 31.1022 22.5 31.5ZM37.5 13.5C37.5 13.8978 37.342 14.2794 37.0607 14.5607C36.7794 14.842 36.3978 15 36 15H33C32.6022 15 32.2206 14.842 31.9393 14.5607C31.658 14.2794 31.5 13.8978 31.5 13.5C31.5 13.1022 31.658 12.7206 31.9393 12.4393C32.2206 12.158 32.6022 12 33 12H36C36.3978 12 36.7794 12.158 37.0607 12.4393C37.342 12.7206 37.5 13.1022 37.5 13.5Z"
      fill={color}
      transform="translate(3 7.5024)"
    />
  </FigmaExpenseIcon>
);

export const Car = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M28.5 25.5H36V30C36 30.3978 35.842 30.7794 35.5607 31.0607C35.2794 31.342 34.8978 31.5 34.5 31.5H30C29.6022 31.5 29.2206 31.342 28.9393 31.0607C28.658 30.7794 28.5 30.3978 28.5 30V25.5ZM0 30C0 30.3978 0.158036 30.7794 0.43934 31.0607C0.720645 31.342 1.10218 31.5 1.5 31.5H6C6.39782 31.5 6.77936 31.342 7.06066 31.0607C7.34196 30.7794 7.5 30.3978 7.5 30V25.5H0V30ZM30.3956 0.890625C30.2778 0.625525 30.0856 0.400293 29.8423 0.242216C29.599 0.0841399 29.3151 3.47268e-06 29.025 0H6.975C6.68488 3.47268e-06 6.40099 0.0841399 6.15772 0.242216C5.91445 0.400293 5.72224 0.625525 5.60437 0.890625L0 13.5H36L30.3956 0.890625Z"
      fill={color}
      transform="translate(6 7.5024)"
    />
    <path
      d="M43.5 13.5H41.475L36.2662 1.78125C36.0305 1.25105 35.6461 0.800586 35.1596 0.484433C34.673 0.168281 34.1052 6.94537e-06 33.525 0H11.475C10.8948 6.94537e-06 10.327 0.168281 9.84043 0.484433C9.35389 0.800586 8.96947 1.25105 8.73375 1.78125L3.525 13.5H1.5C1.10218 13.5 0.720644 13.658 0.43934 13.9393C0.158035 14.2206 0 14.6022 0 15C0 15.3978 0.158035 15.7794 0.43934 16.0607C0.720644 16.342 1.10218 16.5 1.5 16.5H3V31.5C3 32.2956 3.31607 33.0587 3.87868 33.6213C4.44129 34.1839 5.20435 34.5 6 34.5H10.5C11.2956 34.5 12.0587 34.1839 12.6213 33.6213C13.1839 33.0587 13.5 32.2956 13.5 31.5V28.5H31.5V31.5C31.5 32.2956 31.8161 33.0587 32.3787 33.6213C32.9413 34.1839 33.7044 34.5 34.5 34.5H39C39.7956 34.5 40.5587 34.1839 41.1213 33.6213C41.6839 33.0587 42 32.2956 42 31.5V16.5H43.5C43.8978 16.5 44.2794 16.342 44.5607 16.0607C44.842 15.7794 45 15.3978 45 15C45 14.6022 44.842 14.2206 44.5607 13.9393C44.2794 13.658 43.8978 13.5 43.5 13.5ZM11.475 3H33.525L38.1919 13.5H6.80813L11.475 3ZM10.5 31.5H6V28.5H10.5V31.5ZM34.5 31.5V28.5H39V31.5H34.5ZM39 25.5H6V16.5H39V25.5ZM9 21C9 20.6022 9.15804 20.2206 9.43934 19.9393C9.72064 19.658 10.1022 19.5 10.5 19.5H13.5C13.8978 19.5 14.2794 19.658 14.5607 19.9393C14.842 20.2206 15 20.6022 15 21C15 21.3978 14.842 21.7794 14.5607 22.0607C14.2794 22.342 13.8978 22.5 13.5 22.5H10.5C10.1022 22.5 9.72064 22.342 9.43934 22.0607C9.15804 21.7794 9 21.3978 9 21ZM30 21C30 20.6022 30.158 20.2206 30.4393 19.9393C30.7206 19.658 31.1022 19.5 31.5 19.5H34.5C34.8978 19.5 35.2794 19.658 35.5607 19.9393C35.842 20.2206 36 20.6022 36 21C36 21.3978 35.842 21.7794 35.5607 22.0607C35.2794 22.342 34.8978 22.5 34.5 22.5H31.5C31.1022 22.5 30.7206 22.342 30.4393 22.0607C30.158 21.7794 30 21.3978 30 21Z"
      fill={color}
      transform="translate(1.5024 6)"
    />
  </FigmaExpenseIcon>
);

export const ShirtFolded = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M30 1.5V30C30 30.3978 29.842 30.7794 29.5607 31.0607C29.2794 31.342 28.8978 31.5 28.5 31.5H1.5C1.10218 31.5 0.720645 31.342 0.43934 31.0607C0.158036 30.7794 0 30.3978 0 30V1.5C0 1.10218 0.158036 0.720645 0.43934 0.43934C0.720645 0.158036 1.10218 0 1.5 0H6V10.5C5.99989 10.7851 6.08105 11.0644 6.23395 11.305C6.38686 11.5457 6.60519 11.7377 6.86335 11.8588C7.12151 11.9798 7.40882 12.0247 7.6916 11.9883C7.97438 11.9519 8.24092 11.8356 8.46 11.6531L15 6L21.54 11.6494C21.7588 11.8316 22.025 11.9479 22.3075 11.9844C22.5899 12.021 22.8769 11.9764 23.135 11.8558C23.393 11.7352 23.6114 11.5437 23.7645 11.3036C23.9177 11.0635 23.9994 10.7848 24 10.5V0H28.5C28.8978 0 29.2794 0.158036 29.5607 0.43934C29.842 0.720645 30 1.10218 30 1.5Z"
      fill={color}
      transform="translate(9 9)"
    />
    <path
      d="M30 3H26.1206L23.5613 0.43875C23.4218 0.299499 23.2564 0.189078 23.0743 0.113796C22.8922 0.0385137 22.697 -0.000154479 22.5 4.63798e-07H10.5C10.303 -0.000154479 10.1078 0.0385137 9.92573 0.113796C9.74363 0.189078 9.57816 0.299499 9.43875 0.43875L6.87938 3H3C2.20435 3 1.44129 3.31607 0.87868 3.87868C0.31607 4.44129 0 5.20435 0 6V34.5C0 35.2956 0.31607 36.0587 0.87868 36.6213C1.44129 37.1839 2.20435 37.5 3 37.5H30C30.7956 37.5 31.5587 37.1839 32.1213 36.6213C32.6839 36.0587 33 35.2956 33 34.5V6C33 5.20435 32.6839 4.44129 32.1213 3.87868C31.5587 3.31607 30.7956 3 30 3ZM22.7325 3.855L24 5.12063V15L18.4819 10.23L22.7325 3.855ZM9 5.12063L10.2675 3.855L14.5181 10.23L9 15V5.12063ZM3 6H6V15C5.99648 15.5709 6.15747 16.1307 6.46371 16.6125C6.76995 17.0943 7.20848 17.4777 7.72687 17.7169C8.12555 17.9029 8.56006 17.9995 9 18C9.69986 17.9987 10.3769 17.7511 10.9125 17.3006C10.9202 17.2954 10.9272 17.2891 10.9331 17.2819L15 13.7775V34.5H3V6ZM30 34.5H18V13.7775L22.0594 17.2838C22.0653 17.291 22.0723 17.2973 22.08 17.3025C22.6178 17.754 23.2978 18.001 24 18C24.4429 17.9989 24.8801 17.9003 25.2806 17.7112C25.7967 17.4714 26.2331 17.0884 26.5379 16.6078C26.8427 16.1272 27.0031 15.5691 27 15V6H30V34.5Z"
      fill={color}
      transform="translate(7.5024 4.4976)"
    />
  </FigmaExpenseIcon>
);

export const PersonSimpleThrow = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M9 4.5C9 5.39002 8.73608 6.26005 8.24162 7.00007C7.74715 7.74009 7.04435 8.31686 6.22208 8.65746C5.39981 8.99805 4.49501 9.08717 3.6221 8.91353C2.74918 8.7399 1.94736 8.31132 1.31802 7.68198C0.688685 7.05264 0.260102 6.25082 0.0864683 5.37791C-0.0871652 4.50499 0.00194979 3.60019 0.342544 2.77792C0.683138 1.95566 1.25992 1.25285 1.99994 0.758387C2.73996 0.263921 3.60999 0 4.5 0C5.69348 0 6.83807 0.474106 7.68198 1.31802C8.5259 2.16193 9 3.30653 9 4.5Z"
      fill={color}
      transform="translate(19.4976 6)"
    />
    <path
      d="M15.02 12C16.2067 12 17.3667 11.6481 18.3534 10.9888C19.3401 10.3295 20.1092 9.39246 20.5633 8.2961C21.0174 7.19975 21.1362 5.99335 20.9047 4.82946C20.6732 3.66557 20.1018 2.59648 19.2627 1.75736C18.4235 0.918246 17.3544 0.346802 16.1906 0.115291C15.0267 -0.11622 13.8203 0.00259969 12.7239 0.456725C11.6276 0.910851 10.6905 1.67989 10.0312 2.66658C9.37192 3.65328 9.02002 4.81332 9.02002 6C9.02002 7.5913 9.65216 9.11743 10.7774 10.2426C11.9026 11.3679 13.4287 12 15.02 12ZM15.02 3C15.6134 3 16.1934 3.17595 16.6867 3.50559C17.1801 3.83524 17.5646 4.30377 17.7917 4.85195C18.0187 5.40013 18.0781 6.00333 17.9624 6.58527C17.8466 7.16722 17.5609 7.70177 17.1413 8.12132C16.7218 8.54088 16.1872 8.8266 15.6053 8.94236C15.0233 9.05811 14.4201 8.9987 13.872 8.77164C13.3238 8.54458 12.8553 8.16006 12.5256 7.66671C12.196 7.17337 12.02 6.59335 12.02 6C12.02 5.20435 12.3361 4.44129 12.8987 3.87868C13.4613 3.31607 14.2244 3 15.02 3ZM0.0200221 13.5C0.0200221 12.9067 0.195969 12.3266 0.525614 11.8333C0.855258 11.3399 1.32379 10.9554 1.87197 10.7284C2.42015 10.5013 3.02335 10.4419 3.60529 10.5576C4.18724 10.6734 4.72178 10.9591 5.14134 11.3787C5.5609 11.7982 5.84662 12.3328 5.96238 12.9147C6.07813 13.4967 6.01872 14.0999 5.79166 14.6481C5.5646 15.1962 5.18008 15.6648 4.68673 15.9944C4.19339 16.3241 3.61337 16.5 3.02002 16.5C2.22437 16.5 1.46131 16.1839 0.898702 15.6213C0.336092 15.0587 0.0200221 14.2957 0.0200221 13.5ZM32.69 16.2394C32.4418 16.5501 32.0804 16.7495 31.6852 16.7938C31.29 16.8381 30.8934 16.7237 30.5825 16.4756C30.3669 16.3088 26.1369 13.1569 19.46 16.59C19.4075 18.4978 19.2195 20.3995 18.8975 22.2806L24.9781 27.3431C25.2102 27.5363 25.3785 27.795 25.4611 28.0853C25.5437 28.3757 25.5368 28.6843 25.4413 28.9706L22.4413 37.9706C22.3155 38.3481 22.0449 38.6601 21.689 38.838C21.3332 39.0159 20.9212 39.0452 20.5438 38.9194C20.1663 38.7936 19.8543 38.523 19.6764 38.1671C19.4985 37.8113 19.4692 37.3993 19.595 37.0219L22.2706 28.9931L18.1306 25.5431C17.8602 26.4552 17.541 27.3521 17.1744 28.23C14.5963 34.3688 9.97815 38.4731 3.4494 40.4325C3.07163 40.5364 2.6682 40.4885 2.32536 40.2988C1.98252 40.1091 1.72749 39.7929 1.61482 39.4176C1.50214 39.0424 1.54077 38.6379 1.72243 38.2908C1.90408 37.9436 2.21436 37.6813 2.5869 37.56C13.9644 34.1456 15.9256 24.0188 16.3531 18.5006C11.27 21.7275 7.2519 22.5 4.58752 22.5C3.33244 22.5042 2.08561 22.2969 0.899397 21.8869C0.582094 21.7482 0.322534 21.5041 0.164758 21.1958C0.00698151 20.8876 -0.0392916 20.5343 0.0337901 20.1958C0.106872 19.8573 0.294807 19.5546 0.565706 19.3389C0.836605 19.1232 1.17378 19.0079 1.52002 19.0125C1.73442 19.0122 1.94627 19.0589 2.14065 19.1494C2.14065 19.1494 7.15815 21.1519 15.6763 15.3619C25.4806 8.69813 32.1763 13.905 32.4594 14.13C32.6131 14.2533 32.741 14.4057 32.8358 14.5785C32.9305 14.7513 32.9903 14.941 33.0118 15.1369C33.0332 15.3328 33.0158 15.531 32.9606 15.7202C32.9054 15.9093 32.8134 16.0858 32.69 16.2394Z"
      fill={color}
      transform="translate(8.9808 4.4976)"
    />
  </FigmaExpenseIcon>
);

export const Umbrella = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M19.5059 2.67846e-05C19.5059 2.67846e-05 12.0059 6.00003 12.0059 19.5H1.50592C1.29722 19.5009 1.09064 19.4581 0.899394 19.3745C0.70815 19.291 0.536449 19.1684 0.39527 19.0147C0.254091 18.861 0.146542 18.6795 0.079499 18.4819C0.0124564 18.2842 -0.0126039 18.0748 0.0059203 17.8669C0.425184 12.9867 2.66212 8.44188 6.27361 5.13285C9.8851 1.82382 14.6077 -0.00807892 19.5059 2.67846e-05ZM39.0059 17.8669C38.5867 12.9867 36.3497 8.44188 32.7382 5.13285C29.1267 1.82382 24.4041 -0.00807892 19.5059 2.67846e-05C19.5059 2.67846e-05 27.0059 6.00003 27.0059 19.5H37.5059C37.7146 19.5009 37.9212 19.4581 38.1124 19.3745C38.3037 19.291 38.4754 19.1684 38.6166 19.0147C38.7577 18.861 38.8653 18.6795 38.9323 18.4819C38.9994 18.2842 39.0244 18.0748 39.0059 17.8669Z"
      fill={color}
      transform="translate(4.4928 6)"
    />
    <path
      d="M42.0016 19.2507C41.6592 15.3243 40.223 11.5725 37.8559 8.42108C35.4889 5.26968 32.2859 2.84491 28.6104 1.42196C24.9348 -0.000995739 20.9341 -0.365145 17.062 0.370838C13.19 1.10682 9.60187 2.91346 6.70477 5.58572C2.83713 9.13886 0.447633 14.0169 0.011018 19.2507C-0.0245812 19.6649 0.0263078 20.0821 0.160456 20.4756C0.294603 20.8691 0.509081 21.2304 0.790281 21.5367C1.07148 21.8429 1.41326 22.0873 1.79394 22.2545C2.17462 22.4216 2.58589 22.5078 3.00164 22.5076H19.5016V33.0076C19.5016 34.5989 20.1338 36.125 21.259 37.2502C22.3842 38.3755 23.9103 39.0076 25.5016 39.0076C27.0929 39.0076 28.6191 38.3755 29.7443 37.2502C30.8695 36.125 31.5016 34.5989 31.5016 33.0076C31.5016 32.6098 31.3436 32.2282 31.0623 31.9469C30.781 31.6656 30.3995 31.5076 30.0016 31.5076C29.6038 31.5076 29.2223 31.6656 28.941 31.9469C28.6597 32.2282 28.5016 32.6098 28.5016 33.0076C28.5016 33.8032 28.1856 34.5663 27.623 35.1289C27.0604 35.6915 26.2973 36.0076 25.5016 36.0076C24.706 36.0076 23.9429 35.6915 23.3803 35.1289C22.8177 34.5663 22.5016 33.8032 22.5016 33.0076V22.5076H39.0016C39.4182 22.5091 39.8305 22.4239 40.2123 22.2573C40.5941 22.0908 40.937 21.8465 41.2192 21.5401C41.5014 21.2338 41.7167 20.872 41.8515 20.4778C41.9862 20.0836 42.0373 19.6657 42.0016 19.2507ZM3.00164 19.5076C3.33409 15.6436 4.90375 11.9897 7.4776 9.08859C10.0514 6.18744 13.4922 4.19365 17.2891 3.40322C15.0916 6.3826 12.3485 11.6532 12.0335 19.5076H3.00164ZM15.0298 19.5076C15.2904 13.7382 17.0041 9.60572 18.461 7.08759C19.1794 5.8367 20.0312 4.66736 21.0016 3.6001C21.9703 4.66752 22.8202 5.83686 23.5366 7.08759C26.0266 11.3888 26.8141 15.9976 26.9679 19.5076H15.0298ZM29.9641 19.5076C29.6491 11.6532 26.906 6.3826 24.7141 3.39385C28.5136 4.18252 31.9567 6.17703 34.5311 9.08048C37.1055 11.9839 38.6735 15.6411 39.0016 19.5076H29.9641Z"
      fill={color}
      transform="translate(3 4.4928)"
    />
  </FigmaExpenseIcon>
);

export const Barbell = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M7.5 1.5V25.5C7.5 25.8978 7.34196 26.2794 7.06066 26.5607C6.77936 26.842 6.39782 27 6 27H1.5C1.10218 27 0.720645 26.842 0.43934 26.5607C0.158036 26.2794 0 25.8978 0 25.5V1.5C0 1.10218 0.158036 0.720645 0.43934 0.43934C0.720645 0.158036 1.10218 0 1.5 0H6C6.39782 0 6.77936 0.158036 7.06066 0.43934C7.34196 0.720645 7.5 1.10218 7.5 1.5ZM25.5 0H21C20.6022 0 20.2206 0.158036 19.9393 0.43934C19.658 0.720645 19.5 1.10218 19.5 1.5V25.5C19.5 25.8978 19.658 26.2794 19.9393 26.5607C20.2206 26.842 20.6022 27 21 27H25.5C25.8978 27 26.2794 26.842 26.5607 26.5607C26.842 26.2794 27 25.8978 27 25.5V1.5C27 1.10218 26.842 0.720645 26.5607 0.43934C26.2794 0.158036 25.8978 0 25.5 0Z"
      fill={color}
      transform="translate(10.5024 10.5024)"
    />
    <path
      d="M46.5 13.5H45V7.5C45 6.70435 44.6839 5.94129 44.1213 5.37868C43.5587 4.81607 42.7956 4.5 42 4.5H39V3C39 2.20435 38.6839 1.44129 38.1213 0.87868C37.5587 0.31607 36.7956 0 36 0H31.5C30.7044 0 29.9413 0.31607 29.3787 0.87868C28.8161 1.44129 28.5 2.20435 28.5 3V13.5H19.5V3C19.5 2.20435 19.1839 1.44129 18.6213 0.87868C18.0587 0.31607 17.2956 0 16.5 0H12C11.2044 0 10.4413 0.31607 9.87868 0.87868C9.31607 1.44129 9 2.20435 9 3V4.5H6C5.20435 4.5 4.44129 4.81607 3.87868 5.37868C3.31607 5.94129 3 6.70435 3 7.5V13.5H1.5C1.10218 13.5 0.720644 13.658 0.43934 13.9393C0.158035 14.2206 0 14.6022 0 15C0 15.3978 0.158035 15.7794 0.43934 16.0607C0.720644 16.342 1.10218 16.5 1.5 16.5H3V22.5C3 23.2956 3.31607 24.0587 3.87868 24.6213C4.44129 25.1839 5.20435 25.5 6 25.5H9V27C9 27.7956 9.31607 28.5587 9.87868 29.1213C10.4413 29.6839 11.2044 30 12 30H16.5C17.2956 30 18.0587 29.6839 18.6213 29.1213C19.1839 28.5587 19.5 27.7956 19.5 27V16.5H28.5V27C28.5 27.7956 28.8161 28.5587 29.3787 29.1213C29.9413 29.6839 30.7044 30 31.5 30H36C36.7956 30 37.5587 29.6839 38.1213 29.1213C38.6839 28.5587 39 27.7956 39 27V25.5H42C42.7956 25.5 43.5587 25.1839 44.1213 24.6213C44.6839 24.0587 45 23.2956 45 22.5V16.5H46.5C46.8978 16.5 47.2794 16.342 47.5607 16.0607C47.842 15.7794 48 15.3978 48 15C48 14.6022 47.842 14.2206 47.5607 13.9393C47.2794 13.658 46.8978 13.5 46.5 13.5ZM6 22.5V7.5H9V22.5H6ZM16.5 27H12V3H16.5V27ZM36 27H31.5V3H36V23.9681C36 23.9794 36 23.9888 36 24C36 24.0112 36 24.0225 36 24.0319V27ZM42 22.5H39V7.5H42V22.5Z"
      fill={color}
      transform="translate(0 9)"
    />
  </FigmaExpenseIcon>
);

export const Backpack = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M30 9V31.5C30 31.8978 29.842 32.2794 29.5607 32.5607C29.2794 32.842 28.8978 33 28.5 33H24V19.5C24 18.7044 23.6839 17.9413 23.1213 17.3787C22.5587 16.8161 21.7956 16.5 21 16.5H9C8.20435 16.5 7.44129 16.8161 6.87868 17.3787C6.31607 17.9413 6 18.7044 6 19.5V33H1.5C1.10218 33 0.720645 32.842 0.43934 32.5607C0.158036 32.2794 0 31.8978 0 31.5V9C0 6.61305 0.948212 4.32387 2.63604 2.63604C4.32387 0.948212 6.61305 0 9 0H21C23.3869 0 25.6761 0.948212 27.364 2.63604C29.0518 4.32387 30 6.61305 30 9Z"
      fill={color}
      transform="translate(9 9)"
    />
    <path
      d="M24 6.10875V4.5C24 3.30653 23.5259 2.16193 22.682 1.31802C21.8381 0.474106 20.6935 0 19.5 0H13.5C12.3065 0 11.1619 0.474106 10.318 1.31802C9.47411 2.16193 9 3.30653 9 4.5V6.10875C6.50265 6.47275 4.21947 7.72267 2.5672 9.63035C0.914929 11.538 0.00375805 13.9763 0 16.5V39C0 39.7956 0.31607 40.5587 0.87868 41.1213C1.44129 41.6839 2.20435 42 3 42H30C30.7956 42 31.5587 41.6839 32.1213 41.1213C32.6839 40.5587 33 39.7956 33 39V16.5C32.9962 13.9763 32.0851 11.538 30.4328 9.63035C28.7805 7.72267 26.4973 6.47275 24 6.10875ZM13.5 3H19.5C19.8978 3 20.2794 3.15804 20.5607 3.43934C20.842 3.72064 21 4.10218 21 4.5V6H12V4.5C12 4.10218 12.158 3.72064 12.4393 3.43934C12.7206 3.15804 13.1022 3 13.5 3ZM24 28.5H9V27C9 26.6022 9.15804 26.2206 9.43934 25.9393C9.72064 25.658 10.1022 25.5 10.5 25.5H22.5C22.8978 25.5 23.2794 25.658 23.5607 25.9393C23.842 26.2206 24 26.6022 24 27V28.5ZM9 31.5H18V33C18 33.3978 18.158 33.7794 18.4393 34.0607C18.7206 34.342 19.1022 34.5 19.5 34.5C19.8978 34.5 20.2794 34.342 20.5607 34.0607C20.842 33.7794 21 33.3978 21 33V31.5H24V39H9V31.5ZM30 39H27V27C27 25.8065 26.5259 24.6619 25.682 23.818C24.8381 22.9741 23.6935 22.5 22.5 22.5H10.5C9.30653 22.5 8.16193 22.9741 7.31802 23.818C6.47411 24.6619 6 25.8065 6 27V39H3V16.5C3 14.5109 3.79018 12.6032 5.1967 11.1967C6.60322 9.79018 8.51088 9 10.5 9H22.5C24.4891 9 26.3968 9.79018 27.8033 11.1967C29.2098 12.6032 30 14.5109 30 16.5V39ZM21 15C21 15.3978 20.842 15.7794 20.5607 16.0607C20.2794 16.342 19.8978 16.5 19.5 16.5H13.5C13.1022 16.5 12.7206 16.342 12.4393 16.0607C12.158 15.7794 12 15.3978 12 15C12 14.6022 12.158 14.2206 12.4393 13.9393C12.7206 13.658 13.1022 13.5 13.5 13.5H19.5C19.8978 13.5 20.2794 13.658 20.5607 13.9393C20.842 14.2206 21 14.6022 21 15Z"
      fill={color}
      transform="translate(7.5024 1.5024)"
    />
  </FigmaExpenseIcon>
);

export const Island = ({ width = '48', height = '48', color = '#0156F5' }) => (
  <FigmaExpenseIcon width={width} height={height}>
    <path
      opacity="0.2"
      d="M1.5 3.75C1.5 3.00832 1.71993 2.2833 2.13199 1.66661C2.54404 1.04993 3.12971 0.569282 3.81494 0.285453C4.50016 0.00162481 5.25416 -0.0726377 5.98159 0.0720569C6.70902 0.216751 7.3772 0.573905 7.90165 1.09835C8.4261 1.6228 8.78325 2.29098 8.92795 3.01841C9.07264 3.74584 8.99838 4.49984 8.71455 5.18507C8.43072 5.87029 7.95007 6.45596 7.33339 6.86801C6.7167 7.28007 5.99168 7.5 5.25 7.5C4.25544 7.5 3.30161 7.10491 2.59835 6.40165C1.89509 5.69839 1.5 4.74456 1.5 3.75ZM19.5 13.5C7.5 13.5 0 19.5 0 19.5H39C39 19.5 31.5 13.5 19.5 13.5Z"
      fill={color}
      transform="translate(4.5024 22.4976)"
    />
    <path
      d="M41.6733 38.4393C41.5503 38.5933 41.3981 38.7215 41.2255 38.8167C41.0528 38.9118 40.8631 38.9719 40.6672 38.9937C40.4713 39.0155 40.2731 38.9984 40.0838 38.9435C39.8945 38.8886 39.7178 38.7969 39.564 38.6737C39.4946 38.6175 32.2852 33.0018 21.0015 33.0018C9.71772 33.0018 2.50647 38.6268 2.43897 38.6756C2.28495 38.7987 2.1082 38.8903 1.91879 38.9451C1.72938 38.9999 1.53104 39.0169 1.33508 38.995C0.939318 38.9509 0.577298 38.7513 0.328657 38.4403C0.0800168 38.1292 -0.0348763 37.7322 0.00925332 37.3364C0.053383 36.9406 0.25292 36.5786 0.56397 36.33C0.869595 36.0862 7.78647 30.6562 18.9933 30.0581C18.4104 27.7354 18.2021 25.3346 18.3765 22.9462C18.7027 18.8756 20.424 13.4531 26.439 9.35622C25.5179 9.13233 24.5743 9.01469 23.6265 9.0056H23.3133C19.7508 9.12185 17.5121 11.2012 16.4696 15.3656C16.3879 15.6923 16.1987 15.982 15.9324 16.1881C15.6661 16.3942 15.3382 16.5047 15.0015 16.5018C14.8788 16.5025 14.7565 16.4874 14.6377 16.4568C14.2519 16.3603 13.9201 16.1145 13.7155 15.7734C13.5109 15.4324 13.4501 15.024 13.5465 14.6381C15.2808 7.70997 19.7546 6.12185 23.2027 6.0131C24.5722 5.98329 25.9394 6.1378 27.2677 6.47247C26.5496 5.2856 25.4996 4.0481 24.0408 3.4256C22.1658 2.6306 19.884 2.97747 17.2327 4.45872C16.8846 4.65266 16.4737 4.70038 16.0905 4.59137C15.7072 4.48237 15.3829 4.22557 15.189 3.87747C14.995 3.52938 14.9473 3.11849 15.0563 2.73522C15.1653 2.35194 15.4221 2.02766 15.7702 1.83372C19.284 -0.125653 22.4677 -0.517528 25.2352 0.671222C27.5771 1.67622 29.1221 3.62997 30.0858 5.35872C31.2446 3.55122 32.6883 2.32685 34.284 1.80747C36.5077 1.08185 38.904 1.67247 41.409 3.56435C41.7123 3.80889 41.9087 4.16189 41.9563 4.54862C42.004 4.93536 41.8993 5.32547 41.6645 5.63638C41.4296 5.94729 41.0829 6.15459 40.6979 6.21441C40.3128 6.27422 39.9196 6.18185 39.6015 5.95685C37.9308 4.69497 36.4571 4.2581 35.2233 4.65747C33.8565 5.0981 32.8102 6.53247 32.154 7.77185C33.5032 8.04535 34.8013 8.52805 36.0015 9.20247C38.7408 10.7681 42.0015 14.0868 42.0015 21.0037C42.0015 21.4015 41.8434 21.7831 41.5621 22.0644C41.2808 22.3457 40.8993 22.5037 40.5015 22.5037C40.1036 22.5037 39.7221 22.3457 39.4408 22.0644C39.1595 21.7831 39.0015 21.4015 39.0015 21.0037C39.0015 16.605 37.4883 13.5037 34.5015 11.8162C34.1536 11.6186 33.7935 11.4433 33.4233 11.2912C34.3678 13.2113 34.699 15.3753 34.3721 17.49C34.1363 19.0545 33.57 20.5508 32.7108 21.8793C32.4809 22.2018 32.1328 22.4203 31.7424 22.487C31.352 22.5538 30.951 22.4634 30.627 22.2357C30.303 22.008 30.0822 21.6613 30.0128 21.2714C29.9433 20.8815 30.031 20.4799 30.2565 20.1543C30.3952 19.95 33.3183 15.5831 29.6452 10.8975C24.5827 13.7493 21.7908 17.8818 21.3652 23.1956C21.1994 25.4976 21.4426 27.8108 22.0833 30.0281C33.8302 30.3675 41.1183 36.09 41.4333 36.3393C41.7424 36.5868 41.9411 36.9465 41.9861 37.3399C42.031 37.7333 41.9186 38.1285 41.6733 38.4393ZM1.50147 21.7518C1.50147 20.7135 1.80938 19.6985 2.38625 18.8351C2.96313 17.9717 3.78307 17.2988 4.74238 16.9015C5.70169 16.5041 6.75729 16.4002 7.77569 16.6027C8.79409 16.8053 9.72956 17.3053 10.4638 18.0395C11.198 18.7738 11.698 19.7092 11.9006 20.7276C12.1032 21.746 11.9992 22.8016 11.6018 23.7609C11.2045 24.7202 10.5316 25.5402 9.66821 26.1171C8.80486 26.6939 7.78982 27.0018 6.75147 27.0018C5.35908 27.0018 4.02373 26.4487 3.03916 25.4642C2.05459 24.4796 1.50147 23.1442 1.50147 21.7518ZM4.50147 21.7518C4.50147 22.1969 4.63343 22.6319 4.88066 23.0019C5.1279 23.3719 5.4793 23.6603 5.89043 23.8306C6.30157 24.0009 6.75397 24.0454 7.19042 23.9586C7.62688 23.8718 8.02779 23.6575 8.34246 23.3428C8.65713 23.0282 8.87142 22.6273 8.95824 22.1908C9.04505 21.7543 9.0005 21.3019 8.8302 20.8908C8.6599 20.4797 8.37151 20.1283 8.0015 19.881C7.63149 19.6338 7.19648 19.5018 6.75147 19.5018C6.15473 19.5018 5.58244 19.7389 5.16048 20.1609C4.73852 20.5828 4.50147 21.1551 4.50147 21.7518Z"
      fill={color}
      transform="translate(3 4.4976)"
    />
  </FigmaExpenseIcon>
);

export const Recreation = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="51" height="47" viewBox="0 0 51 47" fill="none">
      <path
        d="M9.51953 28.066C9.51953 19.2091 16.6986 12.0234 25.562 12.0234C34.4255 12.0234 41.6046 19.2091 41.6046 28.066"
        fill="#B1DBFF"
      />
      <path
        d="M4.17188 28.0619C4.17188 16.2528 13.7439 6.67188 25.5619 6.67188C37.3799 6.67188 46.9519 16.2528 46.9519 28.0619"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 28.0625H49.6276"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5644 6.67563C27.0411 6.67563 28.2381 5.47855 28.2381 4.00188C28.2381 2.52521 27.0411 1.32812 25.5644 1.32812C24.0877 1.32812 22.8906 2.52521 22.8906 4.00188C22.8906 5.47855 24.0877 6.67563 25.5644 6.67563Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinejoin="round"
      />
      <path
        d="M25.5637 12.0234C18.5852 12.0234 12.6584 16.4886 10.457 22.7185"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2231 29.0101C34.6189 27.6911 32.1055 27.7535 30.6261 29.2419L23.7812 36.0867"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8775 29.0101C29.2732 27.6911 26.7599 27.7535 25.2804 29.2419L21.1094 33.4129"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.51953 45.8913C9.51953 44.0196 9.99189 42.148 10.9277 40.5081C11.7298 39.1088 12.1933 37.5492 12.1933 35.936V30.8915C12.1933 29.4477 13.2806 28.1465 14.7244 28.0662C16.2663 27.986 17.5408 29.207 17.5408 30.74V35.9716C17.5408 37.5759 18.6103 38.9841 20.1522 39.4119C22.8794 40.1694 25.8205 39.394 27.8258 37.3976L35.9719 29.2873C37.6029 27.6652 40.2677 27.6652 41.8987 29.2873L42.5047 29.8933L28.2447 45.9002"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NonEssentialInsurance = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="48" viewBox="0 0 50 48" fill="none">
      <path
        d="M41.1953 42.2203C42.2594 42.2203 43.1219 39.1078 43.1219 35.2641C43.1219 31.4203 42.2594 28.3125 41.1953 28.3125H46.7219C47.7859 28.3125 48.6531 31.425 48.6531 35.2641C48.6531 39.1031 47.7859 42.2203 46.7219 42.2203H41.1953Z"
        fill="#FFC9E4"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1484 44.0451C28.4911 43.7675 28.7216 43.3751 28.7972 42.9407C28.8728 42.5062 28.7884 42.059 28.5595 41.682C28.3307 41.305 27.973 41.0237 27.5527 40.8902C27.1323 40.7567 26.6779 40.7801 26.2734 40.956"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.681 38.9203C27.681 38.3455 27.453 37.7942 27.047 37.3873C26.641 36.9804 26.0902 36.7512 25.5154 36.75C25.3898 36.7514 25.2644 36.7624 25.1404 36.7828C25.0417 36.8 24.9445 36.8251 24.8498 36.8578C23.7763 37.1063 22.7638 37.2094 21.6857 37.4906C20.6076 37.7719 19.3748 38.2828 18.2592 38.5734C17.7156 38.7065 17.2397 39.0342 16.9214 39.4946C16.6032 39.9549 16.4648 40.516 16.5324 41.0715C16.5999 41.627 16.8688 42.1385 17.2881 42.5092C17.7074 42.8798 18.248 43.0839 18.8076 43.0828C18.9349 43.0837 19.062 43.0727 19.1873 43.05C20.5908 42.8358 21.9795 42.5336 23.3451 42.1453C24.3802 41.8996 25.3725 41.4998 26.2888 40.9594C26.7006 40.8012 27.0544 40.5214 27.3031 40.1571C27.5519 39.7928 27.6837 39.3614 27.681 38.9203Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.1487 44.0438C28.1487 44.0438 26.2737 45.5813 24.8675 46.0734C23.8002 46.4021 22.6997 46.6112 21.5862 46.6969C21.0909 46.6956 20.6133 46.5129 20.2436 46.1832C19.874 45.8536 19.638 45.3999 19.5802 44.9079C19.5225 44.416 19.647 43.92 19.9303 43.5137C20.2136 43.1074 20.6359 42.819 21.1175 42.7031"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.143 27.4291C34.386 27.6847 32.616 27.8412 30.8414 27.8978C29.3106 27.9328 27.7814 27.7754 26.2898 27.4291V27.4291C26.1729 27.4195 26.0553 27.4195 25.9383 27.4291C25.6203 27.4291 25.3053 27.4918 25.0116 27.6137C24.7178 27.7355 24.451 27.9141 24.2263 28.1392C24.0016 28.3643 23.8236 28.6315 23.7023 28.9255C23.581 29.2195 23.5189 29.5345 23.5195 29.8525C23.5795 30.6693 23.8724 31.4518 24.3633 32.1073C24.8543 32.7627 25.5229 33.2638 26.2898 33.551C29.0508 34.7228 36.1336 34.7744 36.1336 34.7744"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7109 45.7187C26.5738 45.9896 27.4633 46.1672 28.3641 46.2484C29.951 46.399 31.5522 46.2592 33.0891 45.8359V45.8359C34.6236 45.4447 35.9856 44.5566 36.9624 43.3101C37.9392 42.0637 38.476 40.5289 38.4891 38.9453"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.5914 37.6953L38.4883 39.1766"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.5406 32.2984C23.3172 32.1672 20.7109 31.9141 19.0047 31.9141C16.4406 31.9141 15.8453 32.2984 15.8453 32.2984C15.358 32.4578 14.9316 32.7633 14.6238 33.1733C14.3161 33.5834 14.1419 34.0782 14.125 34.5906C14.1336 35.0089 14.2504 35.4179 14.464 35.7777C14.6776 36.1375 14.9807 36.4358 15.3438 36.6437V36.6437C15.5981 36.7979 15.8749 36.9117 16.1641 36.9812C17.797 37.5976 19.5552 37.8084 21.2875 37.5953C22.9814 37.3775 24.6192 36.8432 26.1156 36.0203C26.4399 35.8683 26.7156 35.6291 26.9118 35.3294C27.108 35.0298 27.217 34.6815 27.2266 34.3234V33.8547"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.1984 28.3127C41.1984 28.3127 39.8625 28.069 38.4891 27.919C37.1156 27.769 37.05 27.7643 33.4453 26.4518C29.8406 25.1393 24.1734 25.4533 20.0531 25.458C18.6322 25.424 17.2132 25.5817 15.8344 25.9268V25.9268C14.5828 26.3955 13.7344 27.1502 13.7344 28.8377C13.7344 30.5252 15.6609 31.969 17.9203 31.969H18.15"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.1969 42.2188H37.6719"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.668 3.97656C24.668 3.97656 29.7727 4.10312 38.4867 7.88125C46.057 11.1625 48.1289 15.3109 48.1289 15.3109C48.1289 15.3109 45.757 14.2891 44.6461 14.2891C43.5352 14.2891 41.9133 15.6203 41.9133 15.6203C41.9133 15.6203 42.0398 11.95 34.882 8.22813C27.7242 4.50625 24.668 3.97656 24.668 3.97656Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.1258 16.0234C32.1258 16.0234 30.307 11.2469 28.793 8.75313C27.6419 6.9805 26.2541 5.37345 24.668 3.97656C24.668 3.97656 22.8867 5.38281 20.7305 8.8C19.3645 11.0979 18.2112 13.5157 17.2852 16.0234C17.2852 16.0234 19.1602 13.3797 24.8977 13.3797C30.5227 13.3797 32.1258 16.0234 32.1258 16.0234Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.125 16.025C32.125 16.025 34.1313 14.0703 36.8125 14.0703C39.4938 14.0703 41.9266 15.6219 41.9266 15.6219"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6688 3.97656C24.6688 3.97656 19.5594 4.10312 10.8453 7.88125C3.275 11.1625 1.20312 15.3109 1.20312 15.3109C1.20312 15.3109 3.575 14.2891 4.68594 14.2891C5.79687 14.2891 7.41875 15.6203 7.41875 15.6203C7.41875 15.6203 7.29219 11.95 14.45 8.22813C21.6078 4.50625 24.6688 3.97656 24.6688 3.97656Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2047 16.025C17.2047 16.025 15.1984 14.0703 12.5172 14.0703C9.83594 14.0703 7.39844 15.6219 7.39844 15.6219"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.668 1.51562V3.97656"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.668 27.7969V13.3828"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8672 27.375C19.8672 27.375 21.7422 27.4969 22.6797 27.6844C23.6172 27.8719 24.3016 28.05 24.3016 28.05"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Subscription = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
      <mask id="path-1-inside-1_6226_98771" fill="white">
        <rect x="4.60938" y="3.53125" width="46.1271" height="30.6101" rx="1.35668" />
      </mask>
      <rect
        x="4.60938"
        y="3.53125"
        width="46.1271"
        height="30.6101"
        rx="1.35668"
        stroke="#414141"
        strokeWidth="3.42857"
        strokeLinejoin="round"
        mask="url(#path-1-inside-1_6226_98771)"
      />
      <rect x="23.1032" y="33.3259" width="9.13916" height="3.71244" stroke="#414141" strokeWidth="1.71429" />
      <path d="M19.2188 37.0312H36.13" stroke="#414141" strokeWidth="1.71429" strokeLinecap="round" />
      <rect
        x="25.2305"
        y="46.2031"
        width="31.1244"
        height="3.79566"
        rx="1.82192"
        fill="#DAD1FA"
        stroke="#414141"
        strokeWidth="1.71429"
      />
      <rect
        x="33.7344"
        y="40"
        width="16.2074"
        height="3.03652"
        rx="0.607308"
        transform="rotate(90 33.7344 40)"
        fill="white"
        stroke="#414141"
        strokeWidth="1.71429"
      />
      <rect
        x="30.6953"
        y="42.4531"
        width="11.3023"
        height="3.03652"
        rx="0.607308"
        transform="rotate(90 30.6953 42.4531)"
        fill="white"
        stroke="#414141"
        strokeWidth="1.71429"
      />
      <rect
        x="50.7383"
        y="40"
        width="16.2074"
        height="3.03652"
        rx="0.607308"
        transform="rotate(90 50.7383 40)"
        fill="white"
        stroke="#414141"
        strokeWidth="1.71429"
      />
      <rect
        x="53.7734"
        y="42.4531"
        width="11.3023"
        height="3.03652"
        rx="0.607308"
        transform="rotate(90 53.7734 42.4531)"
        fill="white"
        stroke="#414141"
        strokeWidth="1.71429"
      />
      <path
        d="M33.358 17.6834C33.9548 18.008 33.9548 18.8647 33.358 19.1893L24.8804 23.8009C24.3093 24.1116 23.6137 23.6981 23.6137 23.0479L23.6137 13.8248C23.6137 13.1746 24.3093 12.7612 24.8804 13.0719L33.358 17.6834Z"
        fill="#DAD1FA"
        stroke="#414141"
        strokeWidth="1.71429"
      />
    </svg>
  );
};

export const School = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
      <path
        d="M8.07422 26.9766H11.7171C11.7171 26.9766 12.0442 53.8626 16.4314 53.8626C18.7306 53.8626 8.6442 53.2198 8.6442 53.2198L8.07422 26.9766Z"
        fill="#B1DBFF"
      />
      <rect x="11.0547" y="36.0625" width="5.29931" height="6.61162" fill="#F5F5F5" />
      <path
        d="M19.2852 26.9811L21.684 25.3672C21.684 25.3672 21.904 53.8672 26.2911 53.8672C28.5904 53.8672 19.8551 53.2243 19.8551 53.2243L19.2852 26.9811Z"
        fill="#B1DBFF"
      />
      <rect
        x="16.1523"
        y="25.8984"
        width="18.6591"
        height="3.64643"
        transform="rotate(-43.9373 16.1523 25.8984)"
        fill="#B1DBFF"
      />
      <rect
        x="41.6328"
        y="28.8672"
        width="16.9808"
        height="3.64643"
        transform="rotate(-137.87 41.6328 28.8672)"
        fill="#B1DBFF"
      />
      <path
        d="M51.6719 26.9766V53.9028H8.17188V26.9766"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5547 27.8672V53.9076H40.9086V27.8672"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.245 17.3438H8.59766L4.84766 26.0694V26.2962H15.87M34.4593 17.3438H51.2405L54.9905 26.2634L49.8477 26.2962H43.8343"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0469 25.7781L29.6658 13.5625L42.7977 25.8343"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0469 29.5594L29.6658 17.3438L42.7977 29.6156"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.8162 43.0254V37.7757C27.8162 37.7757 27.8775 35.4453 24.8763 35.4453C21.875 35.4453 21.875 37.7757 21.875 37.7757V43.0254H27.8162Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.1053 43.0254V37.7757C38.1053 37.7757 38.1666 35.4453 35.1653 35.4453C32.1641 35.4453 32.1641 37.7757 32.1641 37.7757V43.0254H38.1053Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.0896 43.0254V37.7757C49.0896 37.7757 49.151 35.4453 46.1497 35.4453C43.1484 35.4453 43.1484 37.7757 43.1484 37.7757V43.0254H49.0896Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.5156 9.6154C29.965 9.27829 31.2347 8.85688 32.4986 9.29513C33.7626 9.73338 34.8985 9.6727 35.5996 9.29513V5.21665C35.212 5.40625 34.1334 5.53265 32.3807 5.07761C31.802 4.89363 30.5403 4.66724 29.5156 5.36833V9.6154ZM29.5156 9.6154V13.559"
        stroke="#414141"
        strokeWidth="1.71429"
      />
      <circle cx="29.8006" cy="27.1483" r="4.39828" stroke="#414141" strokeWidth="1.71429" />
      <path d="M29.5156 25.4766V27.4475H31.4865" stroke="#414141" strokeWidth="1.71429" strokeLinecap="round" />
      <path d="M17.0469 26.0234L17.0469 29.6127" stroke="#414141" strokeWidth="1.71429" />
      <path d="M42.7969 26.0234L42.7969 29.6127" stroke="#414141" strokeWidth="1.71429" />
      <line x1="11.0547" y1="39.596" x2="16.354" y2="39.596" stroke="#414141" strokeWidth="1.71429" />
      <line x1="22.1992" y1="39.596" x2="27.4985" y2="39.596" stroke="#414141" strokeWidth="1.71429" />
      <line x1="32.4844" y1="39.596" x2="37.7837" y2="39.596" stroke="#414141" strokeWidth="1.71429" />
      <line x1="43.4688" y1="39.596" x2="48.7681" y2="39.596" stroke="#414141" strokeWidth="1.71429" />
      <path d="M13.7578 36.0625L13.7578 42.6741" stroke="#414141" strokeWidth="1.71429" />
      <path d="M24.9023 36.0625L24.9023 42.6741" stroke="#414141" strokeWidth="1.71429" />
      <path d="M35.1875 36.0625L35.1875 42.6741" stroke="#414141" strokeWidth="1.71429" />
      <path d="M46.1719 36.0625L46.1719 42.6741" stroke="#414141" strokeWidth="1.71429" />
      <path
        d="M16.6756 43.0254V37.7757C16.6756 37.7757 16.7369 35.4453 13.7356 35.4453C10.7344 35.4453 10.7344 37.7757 10.7344 37.7757V43.0254H16.6756Z"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const DoubleHouse = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="61" viewBox="0 0 61 61" fill="none">
      <path
        d="M25.9121 20.5859H17.418V29.0801H25.9121V20.5859Z"
        fill="#FFC9E4"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.418 24.8359H25.9121"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6641 20.5859V29.0843"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.6766 17.7961L21.7791 3.625L21.6645 3.77774L21.5499 3.625L2.65234 17.7961L5.20229 21.1946L21.6645 8.84793L38.1267 21.1946L40.6766 17.7961Z"
        fill="#FFC9E4"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.9253 13.4865V6.8125H30.5V10.1686"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.22956 19.0933C9.22956 18.6362 8.859 18.2656 8.40189 18.2656C7.94478 18.2656 7.57422 18.6362 7.57422 19.0933V36.0646C7.57422 36.5092 7.75082 36.9356 8.06518 37.2499C8.37953 37.5643 8.80589 37.7409 9.25046 37.7409H22.3453V36.0855H9.25046C9.24491 36.0855 9.2396 36.0833 9.23568 36.0794C9.23176 36.0755 9.22956 36.0702 9.22956 36.0646V19.0933Z"
        fill="#414141"
      />
      <path
        d="M34.0877 26.8414L35.743 25.8121V19.0933C35.743 18.6362 35.3725 18.2656 34.9154 18.2656C34.4583 18.2656 34.0877 18.6362 34.0877 19.0933V26.8414Z"
        fill="#414141"
      />
      <path
        d="M52.1697 39.2734V56.2448C52.1697 56.4698 52.0803 56.6857 51.9212 56.8448C51.7621 57.0039 51.5462 57.0933 51.3212 57.0933H26.5048C26.2798 57.0933 26.0639 57.0039 25.9048 56.8448C25.7457 56.6857 25.6562 56.4698 25.6562 56.2448V39.2734"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.166 40.7656H34.6719V49.2598H43.166V40.7656Z"
        fill="#FFC9E4"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.6719 45.0156H43.166"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.918 40.7656V49.264"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.9305 37.9758L39.033 23.8047L38.9184 23.9574L38.8038 23.8047L19.9062 37.9758L22.4562 41.3743L38.9184 29.0276L55.3806 41.3743L57.9305 37.9758Z"
        fill="#FFC9E4"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.1792 33.6662V26.9922H47.7539V30.3483"
        stroke="#414141"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Flight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="45" height="44" viewBox="0 0 45 44" fill="none">
      <path
        d="M18.2202 32.3978C19.3734 31.575 20.4583 30.6604 21.4642 29.6628L26.3275 24.7995L33.53 17.5713L39.221 11.8803C41.0813 10.0329 42.3837 7.69892 42.979 5.14564C43.1019 4.68936 43.1023 4.20876 42.9803 3.75225C42.8583 3.29574 42.6181 2.87945 42.284 2.54532C41.9499 2.21119 41.5336 1.97101 41.0771 1.849C40.6206 1.72698 40.14 1.72743 39.6837 1.85029C37.1304 2.44561 34.7964 3.748 32.949 5.60833L27.258 11.2994L20.0298 18.5275L15.0791 23.4783C14.1093 24.4487 13.2172 25.4939 12.411 26.604L8.67863 31.7757C8.63356 31.8391 8.59401 31.9062 8.56038 31.9762C8.49442 32.1023 8.44764 32.2374 8.42158 32.3772C8.37951 32.6111 8.39496 32.8518 8.46661 33.0784C8.53826 33.3049 8.66396 33.5107 8.83285 33.6779L11.0949 35.9451C11.22 36.0656 11.3642 36.1646 11.5216 36.2381C11.5992 36.2748 11.6801 36.3041 11.7632 36.3255L11.8866 36.3512C12.1383 36.396 12.3973 36.3729 12.6372 36.2844C12.7615 36.241 12.8792 36.1805 12.9867 36.1044L18.2202 32.3978Z"
        fill="#DAD1FA"
      />
      <path
        d="M15.1369 7.65309L11.0858 6.43469L9.02945 5.81777C8.53531 5.66799 8.00975 5.65536 7.50898 5.78123C7.00822 5.9071 6.55109 6.16674 6.1865 6.53237L4.04787 8.671C3.98666 8.73193 3.94035 8.80618 3.91258 8.88796C3.8848 8.96974 3.87631 9.05683 3.88776 9.14244C3.8992 9.22804 3.93028 9.30984 3.97857 9.38145C4.02686 9.45306 4.09104 9.51254 4.16611 9.55524L20.0311 18.5262L27.2592 11.298L15.1369 7.65309Z"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.2717 40.6583C35.3144 40.7334 35.3739 40.7976 35.4455 40.8458C35.5171 40.8941 35.5989 40.9252 35.6845 40.9367C35.7701 40.9481 35.8572 40.9396 35.939 40.9118C36.0208 40.8841 36.095 40.8378 36.156 40.7765L38.2946 38.6379C38.6602 38.2733 38.9199 37.8162 39.0457 37.3154C39.1716 36.8147 39.159 36.2891 39.0092 35.795L38.3923 33.7386L37.1739 29.6875L33.5289 17.5703L26.3008 24.7985L35.2717 40.6583Z"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4356 34.3674L12.9885 36.0999C12.9309 36.1396 12.8708 36.1757 12.8086 36.2079L17.8673 42.5312C17.952 42.6378 18.0583 42.7252 18.1791 42.7878C18.3 42.8504 18.4327 42.8868 18.5686 42.8946C18.7045 42.9024 18.8405 42.8813 18.9677 42.8329C19.0949 42.7845 19.2104 42.7097 19.3067 42.6135L20.0522 41.8681C20.3043 41.616 20.4825 41.2997 20.5677 40.9535C20.6529 40.6074 20.6417 40.2445 20.5354 39.9042L18.222 32.3984L18.0524 32.5218L15.4356 34.3674Z"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4225 29.3558L12.3657 26.6671L12.412 26.6003L4.92678 24.292C4.5865 24.1857 4.22362 24.1745 3.87746 24.2597C3.53129 24.3449 3.21503 24.5232 2.96294 24.7752L2.21236 25.5258C2.11617 25.6221 2.04141 25.7377 1.99296 25.8649C1.94452 25.9921 1.9235 26.1281 1.93126 26.264C1.93903 26.3999 1.97541 26.5326 2.03802 26.6534C2.10064 26.7743 2.18808 26.8806 2.29461 26.9653L8.56143 31.9726C8.59505 31.9025 8.63461 31.8354 8.67967 31.7721L10.4225 29.3558Z"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4343 34.3718L10.4219 29.3594"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2202 32.3978C19.3734 31.575 20.4583 30.6604 21.4642 29.6628L26.3275 24.7995L33.53 17.5713L39.221 11.8803C41.0813 10.0329 42.3837 7.69892 42.979 5.14564C43.1019 4.68936 43.1023 4.20876 42.9803 3.75225C42.8583 3.29574 42.6181 2.87945 42.284 2.54532C41.9499 2.21119 41.5336 1.97101 41.0771 1.849C40.6206 1.72698 40.14 1.72743 39.6837 1.85029C37.1304 2.44561 34.7964 3.748 32.949 5.60833L27.258 11.2994L20.0298 18.5275L15.0791 23.4783C14.1093 24.4487 13.2172 25.4939 12.411 26.604L8.67863 31.7757C8.63356 31.8391 8.59401 31.9062 8.56038 31.9762C8.49442 32.1023 8.44764 32.2374 8.42158 32.3772C8.37951 32.6111 8.39496 32.8518 8.46661 33.0784C8.53826 33.3049 8.66396 33.5107 8.83285 33.6779L11.0949 35.9451C11.22 36.0656 11.3642 36.1646 11.5216 36.2381C11.5992 36.2748 11.6801 36.3041 11.7632 36.3255L11.8866 36.3512C12.1383 36.396 12.3973 36.3729 12.6372 36.2844C12.7615 36.241 12.8792 36.1804 12.9867 36.1044L18.2202 32.3978Z"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.7344 5.82031L38.5131 6.31384L39.0067 8.09261"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8516 6.6683L15.1726 3.34724C15.3565 3.16484 15.6051 3.0625 15.8641 3.0625C16.1231 3.0625 16.3716 3.16484 16.5555 3.34724L17.9436 4.73016C18.1263 4.91494 18.2288 5.16432 18.2288 5.42419C18.2288 5.68405 18.1263 5.93343 17.9436 6.11821L16.1134 7.94325"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.8867 28.7169L38.7169 26.8868C38.9017 26.704 39.1511 26.6016 39.4109 26.6016C39.6708 26.6016 39.9202 26.704 40.105 26.8868L41.4879 28.2748C41.6703 28.4587 41.7726 28.7072 41.7726 28.9663C41.7726 29.2253 41.6703 29.4738 41.4879 29.6577L38.1617 32.9788"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/**
 * @param {Object} props
 * @param {number} [props.size=48]
 */
export function MoneyEnvelopeIcon({ size = 48 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 48 48" fill="none">
      <path
        d="M7.8125 36.0391C6.125 34.1016 4.375 29.8516 2.6875 20.2266L1.625 16.9766L0.5 17.8516V28.1016L1 45.1018L2.375 46.4518H32.75C11.3125 43.3516 7.8125 36.0391 7.8125 36.0391Z"
        fill="#FFC9E4"
      />
      <path
        d="M4.36719 20.4795V11.7409C4.36719 11.4387 4.48722 11.1489 4.70089 10.9353C4.91455 10.7216 5.20434 10.6016 5.50651 10.6016H41.9649C42.267 10.6016 42.5568 10.7216 42.7705 10.9353C42.9842 11.1489 43.1042 11.4387 43.1042 11.7409V20.5763M4.37256 15.0273L1.07422 17.7503M37.8718 10.6011L28.1419 2.55744C26.9183 1.55053 25.3829 1 23.7983 1C22.2136 1 20.6782 1.55053 19.4546 2.55744L9.73047 10.6011M46.5234 17.7515L43.1055 14.9316M24.1338 15.0276V16.8686M26.6335 19.0051C26.6335 19.0051 26.6335 17.0432 24.1373 17.0432C21.6411 17.0432 21.5752 19.5687 21.5752 19.5687C21.5752 19.5687 21.5752 22.1674 24.097 22.1674C26.6298 22.1674 26.6225 24.7697 26.6225 24.7697C26.6225 24.7697 26.6225 27.2915 24.0604 27.2915C21.4984 27.2915 21.6118 25.3333 21.6118 25.3333M24.1338 27.6018V29.4429M19.4572 32.9391L1.07422 17.752V44.1729C1.07422 44.7772 1.31429 45.3568 1.74162 45.7841C2.16895 46.2115 2.74853 46.4515 3.35287 46.4515H44.2489C44.8532 46.4515 45.4328 46.2115 45.8601 45.7841C46.2875 45.3568 46.5275 44.7772 46.5275 44.1729V17.752L28.1446 32.9391C26.9209 33.946 25.3855 34.4966 23.8009 34.4966C22.2162 34.4966 20.6808 33.946 19.4572 32.9391Z"
        stroke="#414141"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const Wallet = ({ width = '23', height = '25' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 23 25" fill="none">
      <path
        d="M18.7343 5.51053H2.02582C2.02582 5.51053 0.885147 5.51053 0.859441 4.38915C0.859441 4.38915 0.830522 3.51197 1.98083 3.35774L17.449 1.33991C17.449 1.33991 18.7343 1.20818 18.7343 2.46129V5.51053Z"
        fill="#DAD1FA"
      />
      <path d="M22.209 12.75L13.1543 12.75L11.5156 14.6329L13.2186 16.6282H22.209" fill="#DAD1FA" />
      <path
        d="M18.6215 5.49915H21.0313C21.3594 5.49915 21.6741 5.62948 21.9061 5.86147C22.1381 6.09346 22.2684 6.40811 22.2684 6.73619V22.384C22.2684 22.5463 22.2364 22.707 22.1742 22.8569C22.112 23.0068 22.0208 23.143 21.9059 23.2576C21.791 23.3722 21.6546 23.463 21.5045 23.5249C21.3544 23.5867 21.1937 23.6183 21.0313 23.6179H2.0737C1.74646 23.6179 1.43262 23.4879 1.20123 23.2565C0.969838 23.0251 0.839844 22.7113 0.839844 22.384V4.39062"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeMiterlimit="10"
      />
      <path
        d="M18.7343 5.51053H2.02582C2.02582 5.51053 0.885147 5.51053 0.859441 4.38915C0.859441 4.38915 0.830522 3.51197 1.98083 3.35774L17.449 1.33991C17.449 1.33991 18.7343 1.20818 18.7343 2.46129V5.51053Z"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeMiterlimit="10"
      />
      <path
        d="M22.209 12.75L13.1543 12.75L11.5156 14.6329L13.2186 16.6282H22.209"
        stroke="#414141"
        strokeWidth="0.857143"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlertIcon = ({ color = '#414141' }) => {
  return (
    <svg width="24" height="24" fontSize="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.522 2 22 6.477 22 12C22 17.522 17.522 22 12 22C6.478 22 2 17.522 2 12C2 6.477 6.478 2 12 2ZM12 4C7.589 4 4 7.589 4 12C4 16.411 7.589 20 12 20C16.411 20 20 16.411 20 12C20 7.589 16.411 4 12 4ZM12.0574 9.5C12.5784 9.5 13.0004 9.922 13.0004 10.443V16.558C13.0004 17.078 12.5784 17.5 12.0574 17.5H11.9424C11.4214 17.5 11.0004 17.078 11.0004 16.558V10.443C11.0004 9.922 11.4214 9.5 11.9424 9.5H12.0574ZM12 6C12.553 6 13 6.448 13 7C13 7.552 12.553 8 12 8C11.447 8 11 7.552 11 7C11 6.48743 11.3854 6.06453 11.8832 6.00673L12 6Z"
        fill={color}
      />
    </svg>
  );
};

export const PdfIcon = ({ color = '#DAD1FA', height = '44', width = '35', viewBox = '0 0 35 44' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 35 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.85718 4.54236V8.11379V8.47093L29.8215 8.91736V39.7209H31.875L34.1072 6.1495L7.85718 4.54236Z"
        fill="#DAD1FA"
      />
      <path
        d="M3.53276 34.6174L0.714233 34.421L3.0245 0.714233L29.2422 2.50854L29.0266 5.6351M7.59202 8.51066L7.88851 4.18661L34.1062 5.98092L31.7959 39.6916L29.8207 39.5568M7.64225 31.0951H25.7047M7.64225 34.4391H25.7047M7.64225 37.7859H25.7047M3.53231 8.51278H29.8116V42.3005H3.53231V8.51278Z"
        stroke="#414141"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7254 19.0951H10.6819V20.6873C10.6819 20.9149 10.6282 21.0875 10.5207 21.2052C10.4133 21.3229 10.2778 21.3817 10.1141 21.3817C9.9427 21.3817 9.80459 21.3241 9.69972 21.209C9.59486 21.0914 9.54243 20.92 9.54243 20.6949V16.3597C9.54243 16.1091 9.59998 15.93 9.71507 15.8226C9.83017 15.7152 10.013 15.6615 10.2637 15.6615H11.7254C12.1576 15.6615 12.4901 15.6947 12.7229 15.7612C12.9531 15.8252 13.1513 15.9313 13.3175 16.0796C13.4863 16.228 13.6142 16.4096 13.7012 16.6244C13.7881 16.8393 13.8316 17.081 13.8316 17.3495C13.8316 17.9224 13.6552 18.3572 13.3022 18.6539C12.9492 18.9481 12.4236 19.0951 11.7254 19.0951ZM11.4492 16.517H10.6819V18.2358H11.4492C11.7177 18.2358 11.9415 18.2076 12.1206 18.1513C12.3021 18.0951 12.4403 18.003 12.5349 17.8751C12.6295 17.7472 12.6768 17.5797 12.6768 17.3725C12.6768 17.1244 12.604 16.9224 12.4582 16.7664C12.2945 16.6001 11.9581 16.517 11.4492 16.517ZM15.489 15.6615H16.9737C17.3599 15.6615 17.6911 15.6973 17.9674 15.7689C18.2436 15.8405 18.4943 15.9748 18.7193 16.1717C19.305 16.673 19.5979 17.4352 19.5979 18.4583C19.5979 18.7959 19.5685 19.1041 19.5096 19.3829C19.4508 19.6617 19.36 19.9136 19.2373 20.1387C19.1145 20.3612 18.9572 20.5607 18.7654 20.7371C18.6145 20.8727 18.4495 20.9814 18.2705 21.0632C18.0914 21.1451 17.8983 21.2026 17.6911 21.2359C17.4865 21.2691 17.2551 21.2858 16.9967 21.2858H15.512C15.3048 21.2858 15.1488 21.2551 15.044 21.1937C14.9391 21.1297 14.87 21.0415 14.8368 20.929C14.8061 20.8139 14.7908 20.6655 14.7908 20.4839V16.3597C14.7908 16.1142 14.8457 15.9364 14.9557 15.8264C15.0657 15.7165 15.2435 15.6615 15.489 15.6615ZM15.9302 16.563V20.3804H16.7934C16.9827 20.3804 17.131 20.3752 17.2384 20.365C17.3459 20.3548 17.4571 20.3292 17.5722 20.2883C17.6873 20.2474 17.7871 20.1898 17.8715 20.1156C18.2526 19.7934 18.4431 19.2384 18.4431 18.4506C18.4431 17.8956 18.3587 17.48 18.1899 17.2037C18.0236 16.9275 17.8177 16.7523 17.5722 16.6781C17.3267 16.6014 17.03 16.563 16.6821 16.563H15.9302ZM23.96 16.54H21.7156V17.9787H23.5917C23.7656 17.9787 23.8948 18.0184 23.9792 18.0976C24.0661 18.1744 24.1096 18.278 24.1096 18.4084C24.1096 18.5388 24.0661 18.6424 23.9792 18.7192C23.8922 18.7959 23.763 18.8342 23.5917 18.8342H21.7156V20.6873C21.7156 20.9226 21.6619 21.0978 21.5545 21.2129C21.4496 21.3254 21.3141 21.3817 21.1478 21.3817C20.979 21.3817 20.8409 21.3241 20.7335 21.209C20.6286 21.0939 20.5762 20.92 20.5762 20.6873V16.3597C20.5762 16.196 20.6005 16.063 20.6491 15.9607C20.6977 15.8558 20.7731 15.7804 20.8754 15.7344C20.9803 15.6858 21.1133 15.6615 21.2744 15.6615H23.96C24.1416 15.6615 24.2758 15.7024 24.3628 15.7842C24.4523 15.8635 24.4971 15.9684 24.4971 16.0988C24.4971 16.2318 24.4523 16.3392 24.3628 16.4211C24.2758 16.5004 24.1416 16.54 23.96 16.54Z"
        fill="#414141"
      />
    </svg>
  );
};

export const FileIcon = ({ color = '#0156F5', height = '32', width = '32', viewBox = '0 0 32 32' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox}>
      <path
        opacity="0.2"
        d="M26 9V23C26 23.2652 25.8946 23.5196 25.7071 23.7071C25.5196 23.8946 25.2652 24 25 24H22V13L17 8H10V5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H21L26 9Z"
        fill={color}
      />
      <path
        d="M26.7075 8.2925L21.7075 3.2925C21.6146 3.19967 21.5042 3.12605 21.3829 3.07586C21.2615 3.02568 21.1314 2.9999 21 3H11C10.4696 3 9.96086 3.21071 9.58579 3.58579C9.21071 3.96086 9 4.46957 9 5V7H7C6.46957 7 5.96086 7.21071 5.58579 7.58579C5.21071 7.96086 5 8.46957 5 9V27C5 27.5304 5.21071 28.0391 5.58579 28.4142C5.96086 28.7893 6.46957 29 7 29H21C21.5304 29 22.0391 28.7893 22.4142 28.4142C22.7893 28.0391 23 27.5304 23 27V25H25C25.5304 25 26.0391 24.7893 26.4142 24.4142C26.7893 24.0391 27 23.5304 27 23V9C27.0001 8.86864 26.9743 8.73855 26.9241 8.61715C26.874 8.49576 26.8003 8.38544 26.7075 8.2925ZM21 27H7V9H16.5863L21 13.4138V23.98C21 23.9875 21 23.9938 21 24C21 24.0063 21 24.0125 21 24.02V27ZM25 23H23V13C23.0001 12.8686 22.9743 12.7385 22.9241 12.6172C22.874 12.4958 22.8003 12.3854 22.7075 12.2925L17.7075 7.2925C17.6146 7.19967 17.5042 7.12605 17.3829 7.07586C17.2615 7.02568 17.1314 6.9999 17 7H11V5H20.5863L25 9.41375V23ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H11C10.7348 20 10.4804 19.8946 10.2929 19.7071C10.1054 19.5196 10 19.2652 10 19C10 18.7348 10.1054 18.4804 10.2929 18.2929C10.4804 18.1054 10.7348 18 11 18H17C17.2652 18 17.5196 18.1054 17.7071 18.2929C17.8946 18.4804 18 18.7348 18 19ZM18 23C18 23.2652 17.8946 23.5196 17.7071 23.7071C17.5196 23.8946 17.2652 24 17 24H11C10.7348 24 10.4804 23.8946 10.2929 23.7071C10.1054 23.5196 10 23.2652 10 23C10 22.7348 10.1054 22.4804 10.2929 22.2929C10.4804 22.1054 10.7348 22 11 22H17C17.2652 22 17.5196 22.1054 17.7071 22.2929C17.8946 22.4804 18 22.7348 18 23Z"
        fill={color}
      />
    </svg>
  );
};

export const MobileIcon = ({ color = '#0156F5', height = '32', width = '32', viewBox = '0 0 32 32' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox} fill="none">
      <path opacity="0.2" d="M24 7V25H8V7H24Z" fill={color} />
      <path
        d="M22 2H10C9.20435 2 8.44129 2.31607 7.87868 2.87868C7.31607 3.44129 7 4.20435 7 5V27C7 27.7957 7.31607 28.5587 7.87868 29.1213C8.44129 29.6839 9.20435 30 10 30H22C22.7957 30 23.5587 29.6839 24.1213 29.1213C24.6839 28.5587 25 27.7957 25 27V5C25 4.20435 24.6839 3.44129 24.1213 2.87868C23.5587 2.31607 22.7957 2 22 2ZM9 8H23V24H9V8ZM10 4H22C22.2652 4 22.5196 4.10536 22.7071 4.29289C22.8946 4.48043 23 4.73478 23 5V6H9V5C9 4.73478 9.10536 4.48043 9.29289 4.29289C9.48043 4.10536 9.73478 4 10 4ZM22 28H10C9.73478 28 9.48043 27.8946 9.29289 27.7071C9.10536 27.5196 9 27.2652 9 27V26H23V27C23 27.2652 22.8946 27.5196 22.7071 27.7071C22.5196 27.8946 22.2652 28 22 28Z"
        fill={color}
      />
    </svg>
  );
};
